var _path, _path2, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditingbodytextAmico(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-431"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "freepik--shadow--inject-431",
    points: "212.37 481.37 69.05 398.63 287.41 272.64 430.73 355.39 212.37 481.37",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-431"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "144.26 147.28 29.11 213.76 29.11 91.24 144.26 24.78 144.26 147.28",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "26.86 215.07 29.11 216.41 146.52 148.63 144.26 147.28 26.86 215.07",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.78,16.08,24.85,88.78v135l125.93-72.7Zm-4.26,132.55L29.11,216.41V91.24l117.4-67.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.52 148.63 144.26 147.28 144.26 24.78 146.52 23.46 146.52 148.63",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.78 16.08 148.49 14.77 22.56 87.47 24.86 88.78 150.78 16.08",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.56 87.47 24.86 88.78 24.86 223.79 22.56 222.48 22.56 87.47",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.99 115.96 30.99 118.61 146.52 51.82 144.26 50.48 30.99 115.96",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.19 59.46 86.48 58.14 86.48 183.32 84.19 182 84.19 59.46",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.74 55.69 86.48 58.14 86.48 183.32 90.74 180.85 90.74 55.69",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.52 51.82 146.52 56.73 29.07 124.8 29.07 119.88 146.52 51.82",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.48 86.61 84.19 85.21 29.11 117.04 29.11 119.88 86.48 86.61",
    style: {
      fill: "#fafafa"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--gears--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.67,424.34h0l0,5.47h0a.52.52,0,0,0,.25.42l2.89,2.08a1.5,1.5,0,0,1-.73.31l-8.41.53a.86.86,0,0,0-.79.84v10.15a.85.85,0,0,0,.79.84l8.4.53a1.51,1.51,0,0,1,.72.3l-2.9,2.09a.52.52,0,0,0-.25.42h0l0,5.48h0a.5.5,0,0,0,.29.42l6.31,3.64a1.71,1.71,0,0,0,1.4.07l6.39-3a2.38,2.38,0,0,1,1.47-.08,39,39,0,0,0,5,1.18,1.2,1.2,0,0,1,.92.89l.8,4.22a1,1,0,0,0,.94.77h9.27a1,1,0,0,0,.94-.77l.8-4.22a1.2,1.2,0,0,1,.92-.89,39.16,39.16,0,0,0,5-1.18,2.35,2.35,0,0,1,1.46.08l6.4,3a1.69,1.69,0,0,0,1.39-.07l6.31-3.64a.51.51,0,0,0,.29-.43h0l0-5.47h0a.52.52,0,0,0-.25-.42l-2.89-2.08a1.43,1.43,0,0,1,.73-.31l8.41-.53a.85.85,0,0,0,.78-.84v-6.57h0V434a.85.85,0,0,0-.79-.84l-8.4-.53a1.51,1.51,0,0,1-.72-.3l2.9-2.09a.5.5,0,0,0,.25-.42h0l0-5.47h0a.51.51,0,0,0-.3-.43l-6.3-3.64a1.71,1.71,0,0,0-1.4-.07l-6.39,3a2.38,2.38,0,0,1-1.47.08,39.42,39.42,0,0,0-5-1.18,1.21,1.21,0,0,1-.93-.89l-.8-4.22a1,1,0,0,0-.93-.77H59.15a1,1,0,0,0-.93.77l-.8,4.22a1.21,1.21,0,0,1-.92.89,39.16,39.16,0,0,0-5,1.18,2.35,2.35,0,0,1-1.46-.08l-6.4-3a1.69,1.69,0,0,0-1.39.07L36,423.91A.53.53,0,0,0,35.67,424.34Zm38.78,18.14c-5.89,3.4-15.43,3.4-21.32,0a8.52,8.52,0,0,1-4.2-4.7,9.76,9.76,0,0,1,4.21-4c5.88-3.4,15.43-3.4,21.31,0,2.3,1.33,3.65,2.81,4.11,4.32A8.72,8.72,0,0,1,74.45,442.48Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.67,424.34h0l0,5.47h0a.52.52,0,0,0,.25.42l2.89,2.08a1.5,1.5,0,0,1-.73.31l-8.41.53a.86.86,0,0,0-.79.84v10.15a.85.85,0,0,0,.79.84l8.4.53a1.51,1.51,0,0,1,.72.3l-2.9,2.09a.52.52,0,0,0-.25.42h0l0,5.48h0a.5.5,0,0,0,.29.42l6.31,3.64a1.71,1.71,0,0,0,1.4.07l6.39-3a2.38,2.38,0,0,1,1.47-.08,39,39,0,0,0,5,1.18,1.2,1.2,0,0,1,.92.89l.8,4.22a1,1,0,0,0,.94.77h9.27a1,1,0,0,0,.94-.77l.8-4.22a1.2,1.2,0,0,1,.92-.89,39.16,39.16,0,0,0,5-1.18,2.35,2.35,0,0,1,1.46.08l6.4,3a1.69,1.69,0,0,0,1.39-.07l6.31-3.64a.51.51,0,0,0,.29-.43h0l0-5.47h0a.52.52,0,0,0-.25-.42l-2.89-2.08a1.43,1.43,0,0,1,.73-.31l8.41-.53a.85.85,0,0,0,.78-.84v-6.57h0V434a.85.85,0,0,0-.79-.84l-8.4-.53a1.51,1.51,0,0,1-.72-.3l2.9-2.09a.5.5,0,0,0,.25-.42h0l0-5.47h0a.51.51,0,0,0-.3-.43l-6.3-3.64a1.71,1.71,0,0,0-1.4-.07l-6.39,3a2.38,2.38,0,0,1-1.47.08,39.42,39.42,0,0,0-5-1.18,1.21,1.21,0,0,1-.93-.89l-.8-4.22a1,1,0,0,0-.93-.77H59.15a1,1,0,0,0-.93.77l-.8,4.22a1.21,1.21,0,0,1-.92.89,39.16,39.16,0,0,0-5,1.18,2.35,2.35,0,0,1-1.46-.08l-6.4-3a1.69,1.69,0,0,0-1.39.07L36,423.91A.53.53,0,0,0,35.67,424.34Zm38.78,18.14c-5.89,3.4-15.43,3.4-21.32,0a8.52,8.52,0,0,1-4.2-4.7,9.76,9.76,0,0,1,4.21-4c5.88-3.4,15.43-3.4,21.31,0,2.3,1.33,3.65,2.81,4.11,4.32A8.72,8.72,0,0,1,74.45,442.48Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.57,443.27a.66.66,0,0,0,.09,1l2.1,1.52a1.38,1.38,0,0,1,.74-.31l8.41-.53a.87.87,0,0,0,.79-.84l0-6.57v1.11a.85.85,0,0,1-.78.83l-8.41.53a1.55,1.55,0,0,0-1.14.76A12.78,12.78,0,0,1,86.57,443.27Zm5.34-18.87a.6.6,0,0,1-.25.36l-5,3.6a.66.66,0,0,0-.09,1,13.28,13.28,0,0,1,1.78,2.48,1.52,1.52,0,0,0,.42.46l2.9-2.09a.5.5,0,0,0,.25-.42h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.14,430.18c5.88-3.4,15.42-3.4,21.31,0,3.72,2.14,5.09,5.13,4.11,7.9-.45-1.51-1.8-3-4.11-4.32-5.89-3.4-15.43-3.4-21.31,0a9.7,9.7,0,0,0-4.21,4C48.15,435.1,49.55,432.25,53.14,430.18Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92,444.15a.85.85,0,0,0,.79.83l8.4.53a1.33,1.33,0,0,1,.42.12v-5.47a1.16,1.16,0,0,0-.43-.12l-8.4-.53a.86.86,0,0,1-.78-.73Zm6.77-14.33h0a.58.58,0,0,0,.25.43l2.89,2.07a1.53,1.53,0,0,0,.4-.45,13,13,0,0,1,1.69-2.37l.1-.11a.77.77,0,0,0,.17-.29s0-.06,0-.1a.5.5,0,0,0,0-.21.64.64,0,0,0-.15-.31.63.63,0,0,0-.12-.11l-5-3.6a.58.58,0,0,1-.12-.1.31.31,0,0,1-.1-.16.26.26,0,0,1,0-.17h0Zm0,24a.49.49,0,0,0,.3.41l6.3,3.64a1.68,1.68,0,0,0,1,.17v-5.46a1.61,1.61,0,0,1-1-.18L36,448.75a.54.54,0,0,1-.3-.38Zm41.21,1a2,2,0,0,1,.63.15l6.39,3a1.53,1.53,0,0,0,.57.12v-5.46a1.45,1.45,0,0,1-.57-.12l-6.39-3a2,2,0,0,0-.63-.15Zm-18.54,6.66a1,1,0,0,0,.81.47h9.27a1,1,0,0,0,.57-.2v-5.47a.9.9,0,0,1-.57.2H59.15a1,1,0,0,1-.78-.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.92,444.15a.85.85,0,0,0,.79.83l8.4.53a1.33,1.33,0,0,1,.42.12v-5.47a1.16,1.16,0,0,0-.43-.12l-8.4-.53a.86.86,0,0,1-.78-.73Zm6.77-14.33h0a.58.58,0,0,0,.25.43l2.89,2.07a1.53,1.53,0,0,0,.4-.45,13,13,0,0,1,1.69-2.37l.1-.11a.77.77,0,0,0,.17-.29s0-.06,0-.1a.5.5,0,0,0,0-.21.64.64,0,0,0-.15-.31.63.63,0,0,0-.12-.11l-5-3.6a.58.58,0,0,1-.12-.1.31.31,0,0,1-.1-.16.26.26,0,0,1,0-.17h0Zm0,24a.49.49,0,0,0,.3.41l6.3,3.64a1.68,1.68,0,0,0,1,.17v-5.46a1.61,1.61,0,0,1-1-.18L36,448.75a.54.54,0,0,1-.3-.38Zm41.21,1a2,2,0,0,1,.63.15l6.39,3a1.53,1.53,0,0,0,.57.12v-5.46a1.45,1.45,0,0,1-.57-.12l-6.39-3a2,2,0,0,0-.63-.15Zm-18.54,6.66a1,1,0,0,0,.81.47h9.27a1,1,0,0,0,.57-.2v-5.47a.9.9,0,0,1-.57.2H59.15a1,1,0,0,1-.78-.42Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.28,420.27,36,423.91a.46.46,0,0,0,0,.85l5,3.6a.67.67,0,0,1,.09,1,12.26,12.26,0,0,0-1.79,2.47,1.55,1.55,0,0,1-1.13.76l-8.41.53a.86.86,0,0,0-.79.83v4.7a.86.86,0,0,0,.79.83l8.41.53a1.55,1.55,0,0,1,1.13.76A12.26,12.26,0,0,0,41,443.27a.67.67,0,0,1-.09,1l-5,3.6a.46.46,0,0,0,0,.85l6.31,3.64a1.69,1.69,0,0,0,1.39.07l6.4-3a2.35,2.35,0,0,1,1.46-.08,39.16,39.16,0,0,0,5,1.18,1.21,1.21,0,0,1,.92.89l.8,4.22a1,1,0,0,0,.93.77h9.28a1,1,0,0,0,.93-.77l.8-4.22a1.22,1.22,0,0,1,.93-.89,39.42,39.42,0,0,0,5-1.18,2.38,2.38,0,0,1,1.47.08l6.39,3a1.71,1.71,0,0,0,1.4-.07l6.3-3.64a.47.47,0,0,0,0-.85l-5-3.6a.67.67,0,0,1-.09-1,12.2,12.2,0,0,0,1.78-2.47,1.57,1.57,0,0,1,1.14-.76l8.4-.53a.85.85,0,0,0,.79-.83V434a.85.85,0,0,0-.79-.84l-8.4-.53a1.57,1.57,0,0,1-1.14-.76,12.2,12.2,0,0,0-1.78-2.47.66.66,0,0,1,.09-1l5-3.6a.47.47,0,0,0,0-.85l-6.3-3.64a1.71,1.71,0,0,0-1.4-.07l-6.39,3a2.38,2.38,0,0,1-1.47.08,39.42,39.42,0,0,0-5-1.18,1.21,1.21,0,0,1-.93-.89l-.8-4.22a1,1,0,0,0-.93-.77H59.15a1,1,0,0,0-.93.77l-.8,4.22a1.21,1.21,0,0,1-.92.89,39.16,39.16,0,0,0-5,1.18,2.35,2.35,0,0,1-1.46-.08l-6.4-3A1.69,1.69,0,0,0,42.28,420.27Zm32.17,9.91c5.89,3.4,5.89,8.91,0,12.3s-15.43,3.4-21.32,0-5.88-8.9,0-12.3S68.56,426.78,74.45,430.18Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.28,420.27,36,423.91a.46.46,0,0,0,0,.85l5,3.6a.67.67,0,0,1,.09,1,12.26,12.26,0,0,0-1.79,2.47,1.55,1.55,0,0,1-1.13.76l-8.41.53a.86.86,0,0,0-.79.83v4.7a.86.86,0,0,0,.79.83l8.41.53a1.55,1.55,0,0,1,1.13.76A12.26,12.26,0,0,0,41,443.27a.67.67,0,0,1-.09,1l-5,3.6a.46.46,0,0,0,0,.85l6.31,3.64a1.69,1.69,0,0,0,1.39.07l6.4-3a2.35,2.35,0,0,1,1.46-.08,39.16,39.16,0,0,0,5,1.18,1.21,1.21,0,0,1,.92.89l.8,4.22a1,1,0,0,0,.93.77h9.28a1,1,0,0,0,.93-.77l.8-4.22a1.22,1.22,0,0,1,.93-.89,39.42,39.42,0,0,0,5-1.18,2.38,2.38,0,0,1,1.47.08l6.39,3a1.71,1.71,0,0,0,1.4-.07l6.3-3.64a.47.47,0,0,0,0-.85l-5-3.6a.67.67,0,0,1-.09-1,12.2,12.2,0,0,0,1.78-2.47,1.57,1.57,0,0,1,1.14-.76l8.4-.53a.85.85,0,0,0,.79-.83V434a.85.85,0,0,0-.79-.84l-8.4-.53a1.57,1.57,0,0,1-1.14-.76,12.2,12.2,0,0,0-1.78-2.47.66.66,0,0,1,.09-1l5-3.6a.47.47,0,0,0,0-.85l-6.3-3.64a1.71,1.71,0,0,0-1.4-.07l-6.39,3a2.38,2.38,0,0,1-1.47.08,39.42,39.42,0,0,0-5-1.18,1.21,1.21,0,0,1-.93-.89l-.8-4.22a1,1,0,0,0-.93-.77H59.15a1,1,0,0,0-.93.77l-.8,4.22a1.21,1.21,0,0,1-.92.89,39.16,39.16,0,0,0-5,1.18,2.35,2.35,0,0,1-1.46-.08l-6.4-3A1.69,1.69,0,0,0,42.28,420.27Zm32.17,9.91c5.89,3.4,5.89,8.91,0,12.3s-15.43,3.4-21.32,0-5.88-8.9,0-12.3S68.56,426.78,74.45,430.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.15,456.78a1.28,1.28,0,0,1-1.23-1l-.8-4.22a.92.92,0,0,0-.68-.65,36.88,36.88,0,0,1-5-1.19,2,2,0,0,0-1.24.07l-6.4,3a2,2,0,0,1-1.68-.08L35.81,449a.86.86,0,0,1-.45-.67.83.83,0,0,1,.39-.7l5-3.6a.37.37,0,0,0,.17-.26.41.41,0,0,0-.12-.31A13,13,0,0,1,39,441a1.26,1.26,0,0,0-.88-.6l-8.41-.53a1.17,1.17,0,0,1-1.08-1.14V434a1.17,1.17,0,0,1,1.08-1.14l8.41-.53a1.23,1.23,0,0,0,.88-.6,13,13,0,0,1,1.83-2.53.37.37,0,0,0,.11-.31.35.35,0,0,0-.16-.26l-5-3.6a.84.84,0,0,1-.38-.7.86.86,0,0,1,.45-.67L42.12,420a2,2,0,0,1,1.68-.08l6.4,3a2.09,2.09,0,0,0,1.24.07,36.52,36.52,0,0,1,5-1.19.92.92,0,0,0,.68-.65l.8-4.22a1.28,1.28,0,0,1,1.23-1h9.28a1.3,1.3,0,0,1,1.24,1l.8,4.22a.9.9,0,0,0,.67.65,36.17,36.17,0,0,1,5,1.19,2.13,2.13,0,0,0,1.25-.07l6.39-3a2,2,0,0,1,1.68.08l6.31,3.64a.77.77,0,0,1,.07,1.37l-5,3.6a.35.35,0,0,0-.16.26.44.44,0,0,0,.11.31,12.28,12.28,0,0,1,1.83,2.53,1.24,1.24,0,0,0,.89.6l8.4.53A1.16,1.16,0,0,1,99,434v4.69a1.16,1.16,0,0,1-1.08,1.14l-8.4.53a1.24,1.24,0,0,0-.89.6,12.55,12.55,0,0,1-1.83,2.53.44.44,0,0,0-.11.31.35.35,0,0,0,.16.26l5,3.6a.77.77,0,0,1-.07,1.37l-6.31,3.64a2,2,0,0,1-1.68.08l-6.39-3a2.1,2.1,0,0,0-1.24-.07,37,37,0,0,1-5,1.19.9.9,0,0,0-.67.65l-.8,4.22a1.29,1.29,0,0,1-1.24,1ZM50.94,449a2.38,2.38,0,0,1,.68.09,37.37,37.37,0,0,0,4.93,1.17,1.53,1.53,0,0,1,1.17,1.15l.8,4.21a.69.69,0,0,0,.63.52h9.28a.67.67,0,0,0,.63-.52l.8-4.21A1.53,1.53,0,0,1,71,450.28,37.22,37.22,0,0,0,76,449.11a2.71,2.71,0,0,1,1.69.1l6.39,3a1.43,1.43,0,0,0,1.11-.05l6.31-3.65c.09-.05.14-.11.14-.16s0-.11-.12-.17l-5-3.6a1,1,0,0,1-.14-1.48,12.48,12.48,0,0,0,1.74-2.42,1.83,1.83,0,0,1,1.39-.91l8.4-.54a.54.54,0,0,0,.5-.52V434a.53.53,0,0,0-.5-.53l-8.4-.53a1.86,1.86,0,0,1-1.39-.92,12.6,12.6,0,0,0-1.74-2.42,1,1,0,0,1,.14-1.48l5-3.6c.08-.06.12-.12.12-.17s0-.11-.14-.16l-6.31-3.65a1.43,1.43,0,0,0-1.11,0l-6.39,3a2.64,2.64,0,0,1-1.69.1A36.84,36.84,0,0,0,71,422.38a1.53,1.53,0,0,1-1.18-1.15l-.8-4.21a.67.67,0,0,0-.63-.52H59.15a.69.69,0,0,0-.63.52l-.8,4.21a1.53,1.53,0,0,1-1.17,1.15,37.37,37.37,0,0,0-4.93,1.17,2.61,2.61,0,0,1-1.68-.1l-6.4-3a1.47,1.47,0,0,0-1.11,0l-6.31,3.65a.29.29,0,0,0-.14.16c0,.05.05.11.13.17l5,3.6a1,1,0,0,1,.14,1.48A12.54,12.54,0,0,0,39.5,432a1.86,1.86,0,0,1-1.38.92l-8.41.53a.54.54,0,0,0-.5.52v4.7a.54.54,0,0,0,.5.52l8.41.54a1.83,1.83,0,0,1,1.38.91,12.54,12.54,0,0,0,1.75,2.42,1,1,0,0,1,.27.79,1,1,0,0,1-.41.69l-5,3.6c-.08.06-.13.12-.13.17a.29.29,0,0,0,.14.16l6.31,3.65a1.47,1.47,0,0,0,1.11.05l6.4-3A2.58,2.58,0,0,1,50.94,449Zm12.85-3.69A22.13,22.13,0,0,1,53,442.75c-2.95-1.7-4.57-4-4.57-6.42S50,431.61,53,429.91c6-3.44,15.66-3.44,21.62,0h0c3,1.7,4.57,4,4.57,6.42s-1.62,4.72-4.57,6.42A22.1,22.1,0,0,1,63.79,445.33Zm0-17.39a21.48,21.48,0,0,0-10.5,2.5C50.54,432,49,434.12,49,436.33s1.51,4.3,4.26,5.89c5.79,3.34,15.21,3.34,21,0,2.75-1.59,4.26-3.68,4.26-5.89S77,432,74.29,430.44A21.45,21.45,0,0,0,63.79,427.94Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109,452.67a2.71,2.71,0,0,1-1.64.1l-3.86-1.2a1.76,1.76,0,0,0-1.52.3L99.49,454a.6.6,0,0,0-.25.47h0v4.07h0a.59.59,0,0,0,.36.51l1.37.68-3.52.6a.75.75,0,0,0-.63.76h0v4.08h0a.77.77,0,0,0,0,.25l.69,2.19a1.2,1.2,0,0,0,1.14.8l4.53-.18a2.08,2.08,0,0,1,1.09.34l-.23.24a.68.68,0,0,0-.19.44h0v4.08h0a.58.58,0,0,0,.41.53l4,1.59a1.91,1.91,0,0,0,1.55-.16l2.67-1.78a2.54,2.54,0,0,1,1.6-.32,24.05,24.05,0,0,0,2.57.32,1.75,1.75,0,0,1,1.28.84l1,1.92a1.37,1.37,0,0,0,1.28.7l5-.52a.87.87,0,0,0,.78-.85h0v-2.76a1,1,0,0,1,.51-.36,21.06,21.06,0,0,0,2.07-.76,2.63,2.63,0,0,1,1.64-.11l3.86,1.21a1.81,1.81,0,0,0,1.51-.3l2.54-2.11a.62.62,0,0,0,.24-.45h0v-4.1h0a.57.57,0,0,0-.36-.5l-1.36-.69,3.51-.6a.74.74,0,0,0,.64-.71h0v-4.09h0a.83.83,0,0,0,0-.27l-.68-2.19a1.22,1.22,0,0,0-1.15-.81l-4.53.18a2,2,0,0,1-1.09-.34l.23-.24a.66.66,0,0,0,.19-.45h0v-4.05h0V451h0a.56.56,0,0,0-.41-.5l-4-1.59a1.9,1.9,0,0,0-1.56.16l-2.66,1.77a2.58,2.58,0,0,1-1.61.32c-.84-.15-1.7-.25-2.56-.32a1.72,1.72,0,0,1-1.29-.84l-1-1.92a1.4,1.4,0,0,0-1.28-.69l-5,.52a.85.85,0,0,0-.77,1l.23,1.89a1.1,1.1,0,0,1-.75,1.12A19.38,19.38,0,0,0,109,452.67Zm17.52,10.58c-3,2.49-8.89,3.1-13.19,1.38a7.4,7.4,0,0,1-3.39-2.46,5.25,5.25,0,0,1,1-1.07c3-2.48,8.88-3.1,13.18-1.38a7.51,7.51,0,0,1,3.39,2.45A5.28,5.28,0,0,1,126.56,463.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,452.67a2.71,2.71,0,0,1-1.64.1l-3.86-1.2a1.76,1.76,0,0,0-1.52.3L99.49,454a.6.6,0,0,0-.25.47h0v4.07h0a.59.59,0,0,0,.36.51l1.37.68-3.52.6a.75.75,0,0,0-.63.76h0v4.08h0a.77.77,0,0,0,0,.25l.69,2.19a1.2,1.2,0,0,0,1.14.8l4.53-.18a2.08,2.08,0,0,1,1.09.34l-.23.24a.68.68,0,0,0-.19.44h0v4.08h0a.58.58,0,0,0,.41.53l4,1.59a1.91,1.91,0,0,0,1.55-.16l2.67-1.78a2.54,2.54,0,0,1,1.6-.32,24.05,24.05,0,0,0,2.57.32,1.75,1.75,0,0,1,1.28.84l1,1.92a1.37,1.37,0,0,0,1.28.7l5-.52a.87.87,0,0,0,.78-.85h0v-2.76a1,1,0,0,1,.51-.36,21.06,21.06,0,0,0,2.07-.76,2.63,2.63,0,0,1,1.64-.11l3.86,1.21a1.81,1.81,0,0,0,1.51-.3l2.54-2.11a.62.62,0,0,0,.24-.45h0v-4.1h0a.57.57,0,0,0-.36-.5l-1.36-.69,3.51-.6a.74.74,0,0,0,.64-.71h0v-4.09h0a.83.83,0,0,0,0-.27l-.68-2.19a1.22,1.22,0,0,0-1.15-.81l-4.53.18a2,2,0,0,1-1.09-.34l.23-.24a.66.66,0,0,0,.19-.45h0v-4.05h0V451h0a.56.56,0,0,0-.41-.5l-4-1.59a1.9,1.9,0,0,0-1.56.16l-2.66,1.77a2.58,2.58,0,0,1-1.61.32c-.84-.15-1.7-.25-2.56-.32a1.72,1.72,0,0,1-1.29-.84l-1-1.92a1.4,1.4,0,0,0-1.28-.69l-5,.52a.85.85,0,0,0-.77,1l.23,1.89a1.1,1.1,0,0,1-.75,1.12A19.38,19.38,0,0,0,109,452.67Zm17.52,10.58c-3,2.49-8.89,3.1-13.19,1.38a7.4,7.4,0,0,1-3.39-2.46,5.25,5.25,0,0,1,1-1.07c3-2.48,8.88-3.1,13.18-1.38a7.51,7.51,0,0,1,3.39,2.45A5.28,5.28,0,0,1,126.56,463.25Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.4,462.57a.86.86,0,0,0,.36,1.17l1.82.91,3.51-.6a.74.74,0,0,0,.64-.71v-4a.75.75,0,0,1-.64.67l-4.32.74a1.49,1.49,0,0,0-1.05,1A5.58,5.58,0,0,1,134.4,462.57Zm-.74-11.51a.62.62,0,0,1-.19.44l-1.8,1.91a.76.76,0,0,0,.11,1.16,10.29,10.29,0,0,1,1.08,1,2,2,0,0,0,.38.29l.23-.25a.68.68,0,0,0,.19-.44h0Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.17,455.64c3.71,1.49,5,4.23,3.38,6.54a7.21,7.21,0,0,0-3.38-2.45c-4.3-1.73-10.2-1.11-13.18,1.37a5.84,5.84,0,0,0-1,1.07c-1.15-1.65-.88-3.58,1-5.15C114,454.53,119.87,453.92,124.17,455.64Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,473.85a1.46,1.46,0,0,1,.43.47l1,1.92a1.37,1.37,0,0,0,.73.62v-4.09a1.39,1.39,0,0,1-.73-.61l-1-1.92a1.32,1.32,0,0,0-.41-.48Zm-13.62-.55a.58.58,0,0,0,.41.53l4,1.59a1.91,1.91,0,0,0,1,0v-4.09a1.74,1.74,0,0,1-1,0l-4-1.58a.58.58,0,0,1-.41-.54h0Zm26.31-1.71,3.81,1.2a1.79,1.79,0,0,0,1,0v-4.07a1.74,1.74,0,0,1-1,0l-3.8-1.19Zm-33.38-6.46a.77.77,0,0,0,0,.25l.68,2.19a1.22,1.22,0,0,0,1.15.8l4.53-.18a1.71,1.71,0,0,1,.71.15v-4.09a1.87,1.87,0,0,0-.71-.14l-4.53.18a1.22,1.22,0,0,1-1.15-.8l-.68-2.2a1,1,0,0,1,0-.24Zm2.42-6.61h0a.6.6,0,0,0,.36.51l1.37.68.79-.13a1.51,1.51,0,0,0,1.06-1,5.47,5.47,0,0,1,.32-.85,1.43,1.43,0,0,0,.08-.22c0-.05,0-.11,0-.16a1.07,1.07,0,0,0,0-.32.67.67,0,0,0-.22-.33.59.59,0,0,0-.19-.14l-3.18-1.6a.78.78,0,0,1-.2-.14.41.41,0,0,1-.14-.21.32.32,0,0,1,0-.14Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5,473.85a1.46,1.46,0,0,1,.43.47l1,1.92a1.37,1.37,0,0,0,.73.62v-4.09a1.39,1.39,0,0,1-.73-.61l-1-1.92a1.32,1.32,0,0,0-.41-.48Zm-13.62-.55a.58.58,0,0,0,.41.53l4,1.59a1.91,1.91,0,0,0,1,0v-4.09a1.74,1.74,0,0,1-1,0l-4-1.58a.58.58,0,0,1-.41-.54h0Zm26.31-1.71,3.81,1.2a1.79,1.79,0,0,0,1,0v-4.07a1.74,1.74,0,0,1-1,0l-3.8-1.19Zm-33.38-6.46a.77.77,0,0,0,0,.25l.68,2.19a1.22,1.22,0,0,0,1.15.8l4.53-.18a1.71,1.71,0,0,1,.71.15v-4.09a1.87,1.87,0,0,0-.71-.14l-4.53.18a1.22,1.22,0,0,1-1.15-.8l-.68-2.2a1,1,0,0,1,0-.24Zm2.42-6.61h0a.6.6,0,0,0,.36.51l1.37.68.79-.13a1.51,1.51,0,0,0,1.06-1,5.47,5.47,0,0,1,.32-.85,1.43,1.43,0,0,0,.08-.22c0-.05,0-.11,0-.16a1.07,1.07,0,0,0,0-.32.67.67,0,0,0-.22-.33.59.59,0,0,0-.19-.14l-3.18-1.6a.78.78,0,0,1-.2-.14.41.41,0,0,1-.14-.21.32.32,0,0,1,0-.14Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102,451.87,99.49,454a.53.53,0,0,0,.11,1l3.18,1.6a.87.87,0,0,1,.36,1.17,5.58,5.58,0,0,0-.32.86,1.5,1.5,0,0,1-1,1l-4.32.73a.75.75,0,0,0-.6,1l.69,2.19a1.2,1.2,0,0,0,1.14.81l4.53-.18a2.2,2.2,0,0,1,1.47.62,9.28,9.28,0,0,0,1.08,1,.76.76,0,0,1,.11,1.16l-1.8,1.91a.56.56,0,0,0,.22,1l4,1.59a1.88,1.88,0,0,0,1.55-.16l2.67-1.77a2.54,2.54,0,0,1,1.6-.32c.84.15,1.7.25,2.56.32a1.73,1.73,0,0,1,1.29.84l1,1.92a1.38,1.38,0,0,0,1.28.69l5-.51a.87.87,0,0,0,.77-1l-.22-1.88a1.06,1.06,0,0,1,.74-1.12,20.89,20.89,0,0,0,2.06-.77,2.74,2.74,0,0,1,1.65-.1l3.85,1.21a1.82,1.82,0,0,0,1.52-.3l2.54-2.11a.54.54,0,0,0-.12-1l-3.18-1.6a.87.87,0,0,1-.36-1.17,5.88,5.88,0,0,0,.32-.85,1.48,1.48,0,0,1,1.06-1l4.31-.74a.75.75,0,0,0,.6-1l-.68-2.19a1.22,1.22,0,0,0-1.15-.81l-4.53.18a2.2,2.2,0,0,1-1.47-.62,10.29,10.29,0,0,0-1.08-1,.76.76,0,0,1-.11-1.16l1.8-1.91a.56.56,0,0,0-.22-1l-4-1.59a1.9,1.9,0,0,0-1.56.16l-2.66,1.77a2.58,2.58,0,0,1-1.61.32c-.84-.15-1.7-.25-2.56-.32a1.72,1.72,0,0,1-1.29-.84l-1-1.92a1.4,1.4,0,0,0-1.28-.69l-5,.52a.85.85,0,0,0-.77,1l.23,1.89a1.1,1.1,0,0,1-.75,1.12,19.38,19.38,0,0,0-2.06.76,2.71,2.71,0,0,1-1.64.1l-3.86-1.2A1.76,1.76,0,0,0,102,451.87Zm22.15,3.77c4.3,1.72,5.37,5.13,2.39,7.61s-8.89,3.1-13.19,1.38S108,459.5,111,457,119.87,453.92,124.17,455.64Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.55
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102,451.87,99.49,454a.53.53,0,0,0,.11,1l3.18,1.6a.87.87,0,0,1,.36,1.17,5.58,5.58,0,0,0-.32.86,1.5,1.5,0,0,1-1,1l-4.32.73a.75.75,0,0,0-.6,1l.69,2.19a1.2,1.2,0,0,0,1.14.81l4.53-.18a2.2,2.2,0,0,1,1.47.62,9.28,9.28,0,0,0,1.08,1,.76.76,0,0,1,.11,1.16l-1.8,1.91a.56.56,0,0,0,.22,1l4,1.59a1.88,1.88,0,0,0,1.55-.16l2.67-1.77a2.54,2.54,0,0,1,1.6-.32c.84.15,1.7.25,2.56.32a1.73,1.73,0,0,1,1.29.84l1,1.92a1.38,1.38,0,0,0,1.28.69l5-.51a.87.87,0,0,0,.77-1l-.22-1.88a1.06,1.06,0,0,1,.74-1.12,20.89,20.89,0,0,0,2.06-.77,2.74,2.74,0,0,1,1.65-.1l3.85,1.21a1.82,1.82,0,0,0,1.52-.3l2.54-2.11a.54.54,0,0,0-.12-1l-3.18-1.6a.87.87,0,0,1-.36-1.17,5.88,5.88,0,0,0,.32-.85,1.48,1.48,0,0,1,1.06-1l4.31-.74a.75.75,0,0,0,.6-1l-.68-2.19a1.22,1.22,0,0,0-1.15-.81l-4.53.18a2.2,2.2,0,0,1-1.47-.62,10.29,10.29,0,0,0-1.08-1,.76.76,0,0,1-.11-1.16l1.8-1.91a.56.56,0,0,0-.22-1l-4-1.59a1.9,1.9,0,0,0-1.56.16l-2.66,1.77a2.58,2.58,0,0,1-1.61.32c-.84-.15-1.7-.25-2.56-.32a1.72,1.72,0,0,1-1.29-.84l-1-1.92a1.4,1.4,0,0,0-1.28-.69l-5,.52a.85.85,0,0,0-.77,1l.23,1.89a1.1,1.1,0,0,1-.75,1.12,19.38,19.38,0,0,0-2.06.76,2.71,2.71,0,0,1-1.64.1l-3.86-1.2A1.76,1.76,0,0,0,102,451.87Zm22.15,3.77c4.3,1.72,5.37,5.13,2.39,7.61s-8.89,3.1-13.19,1.38S108,459.5,111,457,119.87,453.92,124.17,455.64Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.09,473.21a1.73,1.73,0,0,1-1.48-.89l-1-1.93a1.38,1.38,0,0,0-1-.64c-.88-.07-1.76-.18-2.6-.33a2.15,2.15,0,0,0-1.35.27L110,471.46a2.2,2.2,0,0,1-1.87.19l-4-1.58a1,1,0,0,1-.61-.67.93.93,0,0,1,.27-.86l1.8-1.92a.39.39,0,0,0,.12-.32.46.46,0,0,0-.19-.33,9.84,9.84,0,0,1-1.12-1,1.9,1.9,0,0,0-1.2-.52l-4.54.19a1.55,1.55,0,0,1-1.49-1.05l-.68-2.19A1.09,1.09,0,0,1,97.4,460l4.31-.74a1.09,1.09,0,0,0,.77-.76,7.75,7.75,0,0,1,.35-.91.52.52,0,0,0-.21-.71l-3.18-1.6a1,1,0,0,1-.55-.71.94.94,0,0,1,.37-.82l2.54-2.11a2.16,2.16,0,0,1,1.84-.37l3.86,1.21a2.33,2.33,0,0,0,1.4-.09,20.76,20.76,0,0,1,2.1-.78.72.72,0,0,0,.5-.74l-.23-1.89a1.19,1.19,0,0,1,.26-.9,1.17,1.17,0,0,1,.82-.45l5-.52a1.72,1.72,0,0,1,1.62.88l1,1.93a1.42,1.42,0,0,0,1,.65,24.3,24.3,0,0,1,2.6.32,2.15,2.15,0,0,0,1.35-.27l2.67-1.77a2.25,2.25,0,0,1,1.88-.19l4,1.59a.92.92,0,0,1,.61.66,1,1,0,0,1-.27.87l-1.8,1.91a.39.39,0,0,0-.12.32.49.49,0,0,0,.19.33,9.84,9.84,0,0,1,1.12,1,1.91,1.91,0,0,0,1.21.52l4.53-.19a1.56,1.56,0,0,1,1.49,1.05l.68,2.19a1.12,1.12,0,0,1-.1.93,1.13,1.13,0,0,1-.77.51l-4.31.74a1.12,1.12,0,0,0-.78.76,6.31,6.31,0,0,1-.35.91.52.52,0,0,0,.21.71l3.18,1.6a1,1,0,0,1,.55.71.94.94,0,0,1-.37.82l-2.53,2.11a2.16,2.16,0,0,1-1.85.37L130,467.83a2.41,2.41,0,0,0-1.4.09,20.76,20.76,0,0,1-2.1.78.72.72,0,0,0-.5.74l.23,1.89a1.19,1.19,0,0,1-.26.9,1.15,1.15,0,0,1-.82.45l-5,.52Zm-6.33-4.5a2.34,2.34,0,0,1,.38,0c.82.14,1.67.25,2.53.31a2.08,2.08,0,0,1,1.57,1l1,1.92a1,1,0,0,0,.94.51l5-.52a.49.49,0,0,0,.35-.19.5.5,0,0,0,.11-.39l-.23-1.88a1.45,1.45,0,0,1,1-1.5,20.43,20.43,0,0,0,2-.74,3,3,0,0,1,1.88-.12l3.86,1.21a1.48,1.48,0,0,0,1.19-.24l2.53-2.11c.09-.07.14-.15.13-.21s-.07-.12-.17-.17l-3.18-1.6a1.2,1.2,0,0,1-.52-1.62,6.64,6.64,0,0,0,.3-.81,1.82,1.82,0,0,1,1.33-1.26l4.31-.73a.45.45,0,0,0,.3-.19.44.44,0,0,0,0-.36l-.68-2.19a.83.83,0,0,0-.8-.56l-4.54.18a2.57,2.57,0,0,1-1.72-.73,9.66,9.66,0,0,0-1.06-.93,1.16,1.16,0,0,1-.45-.83,1.07,1.07,0,0,1,.31-.85l1.79-1.91a.31.31,0,0,0,.11-.24.32.32,0,0,0-.2-.17l-4-1.59a1.54,1.54,0,0,0-1.24.13l-2.66,1.77a2.91,2.91,0,0,1-1.85.37c-.83-.14-1.68-.25-2.54-.31a2.08,2.08,0,0,1-1.57-1l-1-1.92a1.06,1.06,0,0,0-.94-.51l-4.95.52a.53.53,0,0,0-.36.19.54.54,0,0,0-.11.39l.23,1.88a1.43,1.43,0,0,1-1,1.5,18.59,18.59,0,0,0-2,.75,3.15,3.15,0,0,1-1.89.12l-3.86-1.21a1.48,1.48,0,0,0-1.19.23h0l-2.53,2.11a.29.29,0,0,0-.13.21c0,.06.07.12.17.17l3.18,1.6a1.2,1.2,0,0,1,.53,1.62,5.38,5.38,0,0,0-.31.81,1.8,1.8,0,0,1-1.33,1.26l-4.31.73a.46.46,0,0,0-.3.2.42.42,0,0,0,0,.35l.69,2.19a.84.84,0,0,0,.8.56l4.53-.18a2.55,2.55,0,0,1,1.73.73,9.71,9.71,0,0,0,1,.94,1.17,1.17,0,0,1,.46.82,1.14,1.14,0,0,1-.31.85l-1.8,1.91c-.08.09-.12.17-.1.24s.08.13.19.17l4,1.59a1.54,1.54,0,0,0,1.24-.13l2.66-1.77A2.9,2.9,0,0,1,113.76,468.71Zm5-2.76a15,15,0,0,1-5.5-1c-2.42-1-4-2.53-4.25-4.27a4.27,4.27,0,0,1,1.77-3.93c3.07-2.55,9.14-3.19,13.54-1.43,2.43,1,4,2.53,4.25,4.27a4.27,4.27,0,0,1-1.77,3.93A13,13,0,0,1,118.74,466Zm0-10.94a12.18,12.18,0,0,0-7.56,2.27,3.55,3.55,0,0,0-1.53,3.3c.23,1.49,1.63,2.85,3.82,3.73,4.19,1.67,9.94,1.08,12.83-1.32a3.54,3.54,0,0,0,1.53-3.29c-.23-1.5-1.63-2.86-3.82-3.74A14.45,14.45,0,0,0,118.77,455Z",
    style: {
      fill: "#fff"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--window--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.65,20.36V236a8.58,8.58,0,0,0,3.9,6.74L460.14,345.3a2.51,2.51,0,0,0,1.28.38c1.52,0,2.62-1.67,2.62-3.63V127.33a8.64,8.64,0,0,0-3.9-6.75L282.54,18.11a3.51,3.51,0,0,0-1.73-.52C279.53,17.59,278.65,18.6,278.65,20.36Zm1.31,0c0-.55.11-1.46.85-1.46a2.3,2.3,0,0,1,1.08.35L459.48,121.73a7.27,7.27,0,0,1,3.24,5.6V342.05c0,1.23-.61,2.31-1.3,2.31a1.21,1.21,0,0,1-.63-.2L283.2,241.62A7.22,7.22,0,0,1,280,236Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,20.36V236a7.22,7.22,0,0,0,3.24,5.59L460.79,344.16a1.21,1.21,0,0,0,.63.2c.69,0,1.3-1.08,1.3-2.31V127.33a7.27,7.27,0,0,0-3.24-5.6L281.89,19.25a2.3,2.3,0,0,0-1.08-.35C280.07,18.9,280,19.81,280,20.36Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.37,342.61c-.42.22-3.45,1.95-4.78,2.7A4,4,0,0,0,464,342v-202l5-2.92V339.23A3.8,3.8,0,0,1,467.37,342.61Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.37,342.61c-.42.22-3.45,1.95-4.78,2.7A4,4,0,0,0,464,342v-202l5-2.92V339.23A3.8,3.8,0,0,1,467.37,342.61Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,163.39,318.19,83.86V66.49L456,146ZM318.85,83.48l136.44,78.78V146.4L318.85,67.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,190.93,318.19,111.4V94L456,173.56ZM318.85,111,455.29,189.8V173.94L318.85,95.16Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,330.48l-.54-.31L286.69,232.75V103.34l.55.32L456,201.08ZM287.42,232.33l167.84,96.9V201.5L287.42,104.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.12,119.54l.35.1c.2.06.21-.08.21-.39v-4.77c0-.32,0-.44-.22-.61l-.34-.29V113l2.17,1.26a2.92,2.92,0,0,1,1.56,2.67c0,.71-.3,1.28-.79,1.17v0a2.72,2.72,0,0,1,1.05,2.19c0,.93-.23,2-1.9,1.07l-2.09-1.21Zm2.7-3.13a1.81,1.81,0,0,0-.9-1.69l-.25-.14V117a3,3,0,0,0,.27.18C294.59,117.58,294.82,117.26,294.82,116.41Zm.27,3.32a1.94,1.94,0,0,0-1.07-1.8,2.25,2.25,0,0,0-.35-.18v2.52a3.68,3.68,0,0,0,.44.31C294.9,121,295.09,120.5,295.09,119.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.64,120.69l.15-.41,1.79,1-.15.41-.61-.19-1.54,5,.6.48-.16.42-1.85-1.07L303,126l.57.19,1.56-5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.19,130.18v-3.4c0-.32,0-.45-.22-.61l-.37-.31v-.5l1.84,1.07v.49l-.38-.13c-.19-.06-.2.1-.2.41v3.29c0,1.52.32,2.41,1.21,2.92s1.26.13,1.26-1.57v-3.26c0-.31,0-.44-.22-.61l-.37-.3v-.49l1.64.94v.5l-.38-.13c-.19-.06-.21.1-.21.41V132c0,2.18-.66,2.76-1.82,2.08C314.6,133.28,314.19,131.85,314.19,130.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.62 136.12 314.34 134.22 314.34 133.64 317.62 135.53 317.62 136.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.25 134.82 324.32 131.98 324.32 131.4 329.25 134.24 329.25 134.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.02 135.27 324.32 133.14 324.32 132.56 328.02 134.69 328.02 135.27",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.25 137.13 324.32 134.29 324.32 133.71 329.25 136.55 329.25 137.13",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.02 137.58 324.32 135.45 324.32 134.86 328.02 137 328.02 137.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.25 139.44 324.32 136.6 324.32 136.02 329.25 138.86 329.25 139.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "328.02 139.89 324.32 137.75 324.32 137.17 328.02 139.31 328.02 139.89",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "329.25 141.75 324.32 138.91 324.32 138.33 329.25 141.17 329.25 141.75",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.02 141.04 335.1 138.2 335.1 137.62 340.02 140.46 340.02 141.04",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.4 141.84 335.71 139.71 335.71 139.13 339.4 141.26 339.4 141.84",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.02 143.35 335.1 140.51 335.1 139.93 340.02 142.77 340.02 143.35",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.4 144.15 335.71 142.02 335.71 141.44 339.4 143.57 339.4 144.15",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.02 145.66 335.1 142.82 335.1 142.24 340.02 145.08 340.02 145.66",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.4 146.46 335.71 144.33 335.71 143.75 339.4 145.88 339.4 146.46",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "340.02 147.97 335.1 145.13 335.1 144.55 340.02 147.39 340.02 147.97",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.79 147.26 345.87 144.42 345.87 143.84 350.79 146.68 350.79 147.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.18 148.06 346.49 145.93 346.49 145.35 350.18 147.48 350.18 148.06",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.79 149.57 345.87 146.73 345.87 146.15 350.79 148.99 350.79 149.57",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.18 150.37 346.49 148.24 346.49 147.66 350.18 149.79 350.18 150.37",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.79 151.88 345.87 149.04 345.87 148.46 350.79 151.3 350.79 151.88",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.18 152.68 346.49 150.55 346.49 149.97 350.18 152.1 350.18 152.68",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "350.79 154.19 345.87 151.35 345.87 150.77 350.79 153.61 350.79 154.19",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 153.48 356.64 150.64 356.64 150.06 361.56 152.9 361.56 153.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 154.64 356.64 151.8 356.64 151.21 361.56 154.06 361.56 154.64",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 155.79 356.64 152.95 356.64 152.37 361.56 155.21 361.56 155.79",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 156.95 356.64 154.1 356.64 153.52 361.56 156.37 361.56 156.95",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 158.1 356.64 155.26 356.64 154.68 361.56 157.52 361.56 158.1",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 159.26 356.64 156.41 356.64 155.83 361.56 158.67 361.56 159.26",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 160.41 356.64 157.57 356.64 156.99 361.56 159.83 361.56 160.41",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,158.16c0,.53-.28.79-.63.6a1.66,1.66,0,0,1-.62-1.32c0-.53.28-.8.62-.6A1.63,1.63,0,0,1,368.67,158.16Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.7 160.78 369.39 158.87 369.39 158.28 372.7 160.19 372.7 160.78",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,161.05c0,.53-.28.79-.63.6a1.66,1.66,0,0,1-.62-1.32c0-.53.28-.8.62-.6A1.63,1.63,0,0,1,368.67,161.05Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.7 163.67 369.39 161.76 369.39 161.18 372.7 163.09 372.7 163.67",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.67,163.94c0,.53-.28.79-.63.6a1.66,1.66,0,0,1-.62-1.32c0-.53.28-.8.62-.6A1.63,1.63,0,0,1,368.67,163.94Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "372.7 166.56 369.39 164.65 369.39 164.06 372.7 165.98 372.7 166.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.71 173.48 389.96 170.74 389.96 170.16 394.71 172.9 394.71 173.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.71 174.93 391.68 173.18 391.68 172.6 394.71 174.35 394.71 174.93",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.71 176.38 391.68 174.63 391.68 174.04 394.71 175.79 394.71 176.38",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "394.71 177.82 389.96 175.08 389.96 174.5 394.71 177.24 394.71 177.82",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.52 178.58 389.96 176.52 389.96 175.94 393.52 178 393.52 178.58",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.37 169.83 380.06 167.92 380.06 167.34 383.37 169.25 383.37 169.83",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.37 172.72 380.06 170.81 380.06 170.23 383.37 172.14 383.37 172.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.37 166.94 380.06 165.03 380.06 164.44 383.37 166.35 383.37 166.94",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.37 172.72 380.06 170.81 380.06 170.23 383.37 172.14 383.37 172.72",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.56 153.48 356.64 150.64 356.64 150.06 361.56 152.9 361.56 153.48",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.73,164.51l.12,0s0,0,0-.05v-.81c0-.06,0-.11-.05-.13l-.13-.08v-.15l.34.12.05.08v1.07c0,.09,0,.1,0,.13l.11.09V165l-.53-.31Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.59,167.12a.94.94,0,0,0,.24-.13.39.39,0,0,0,.22-.37.36.36,0,0,0-.15-.35s-.1,0-.13,0a.34.34,0,0,1,0,.15c0,.07,0,.14-.11.09a.26.26,0,0,1-.12-.24c0-.19.15-.29.37-.16a.7.7,0,0,1,.34.63c0,.32-.2.37-.37.44l-.08,0v0l.22.12c.1.06.13.05.18-.14l.11.07,0,.46-.74-.43Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.61,170.36c.3.13.48,0,.48-.21a.52.52,0,0,0-.12-.36.55.55,0,0,1-.18,0l0-.2c.19,0,.28,0,.28-.23a.33.33,0,0,0-.15-.3s-.1,0-.13,0a.31.31,0,0,1,0,.15c0,.07,0,.13-.12.09a.28.28,0,0,1-.11-.24c0-.19.15-.28.38-.15a.64.64,0,0,1,.33.56.25.25,0,0,1-.2.28h0a.75.75,0,0,1,.25.55c0,.38-.28.48-.71.25Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.29 173.17 390.84 172.91 390.84 172.13 389.96 172.66 390.84 174.22 390.84 173.44 391.29 173.7 391.29 173.17",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.19 179.53 400.44 176.79 400.44 176.21 405.19 178.95 405.19 179.53",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.19 180.98 402.16 179.23 402.16 178.65 405.19 180.4 405.19 180.98",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.19 182.43 402.16 180.68 402.16 180.1 405.19 181.84 405.19 182.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.19 183.87 400.44 181.13 400.44 180.55 405.19 183.29 405.19 183.87",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "404 184.63 400.44 182.57 400.44 181.99 404 184.05 404 184.63",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "400.44 178.45 400.89 178.71 400.89 177.93 401.77 179.49 400.89 180.02 400.89 179.24 400.44 178.98 400.44 178.45",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.71,183.87l-2.51-1.45v1.88l2.51,1.45a2.51,2.51,0,0,1,1,2c0,.82-.43,1.24-1,.93l-1.23-.71v-1.13L411,188.09l1.49,2.92v-1.13l1.23.71c1.21.7,2.18-.24,2.18-2.1S414.92,184.57,413.71,183.87Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.06,195.41l2.51,1.45V195l-2.51-1.45a2.57,2.57,0,0,1-1-2c0-.82.43-1.23,1-.93l1.23.71v1.14l1.49-1.21-1.49-2.93v1.13l-1.23-.71c-1.2-.69-2.18.25-2.18,2.1A5.77,5.77,0,0,0,422.06,195.41Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.11,198.24c.24-.26.72-.11,1,.31l.29.4c.16.22.39.29.51.16a.52.52,0,0,0-.06-.63l-.29-.4a2.29,2.29,0,0,0-1.09-.84.89.89,0,0,0-1,.21L432.08,199a2.14,2.14,0,0,0,.27,2.52l.29.4a2.23,2.23,0,0,0,1.08.84.9.9,0,0,0,1-.21l.69-.73a.54.54,0,0,0-.07-.63c-.16-.22-.39-.29-.51-.16l-.69.73c-.24.25-.71.11-1-.32l-.29-.39a1.08,1.08,0,0,1-.14-1.26l1.45-1.54Zm2.48,2.29L438,199a1.39,1.39,0,0,0,.29-1.13,2.89,2.89,0,0,0-.56-1.39l-.29-.4a2.23,2.23,0,0,0-1.08-.84.89.89,0,0,0-1,.21l-.63.66a.54.54,0,0,0,.07.63c.16.22.39.29.51.16l.63-.66a.44.44,0,0,1,.48-.11,1.14,1.14,0,0,1,.55.42l.29.4a1.57,1.57,0,0,1,.28.7.71.71,0,0,1-.15.56L436,199.74c-.24.25-.72.1-1-.32-.16-.22-.39-.29-.51-.16a.54.54,0,0,0,.07.63,2.19,2.19,0,0,0,1.08.85.91.91,0,0,0,1-.21Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445,204.49c.24-.25.72-.1,1,.32l.29.4c.16.21.39.29.51.15a.54.54,0,0,0-.07-.63l-.29-.39a2.23,2.23,0,0,0-1.08-.84.9.9,0,0,0-1,.2l-1.45,1.54a2.16,2.16,0,0,0,.27,2.53l.29.39a2.17,2.17,0,0,0,1.08.84.9.9,0,0,0,1-.2l.69-.73a.54.54,0,0,0-.07-.63c-.16-.22-.39-.29-.51-.16L445,208c-.24.25-.72.1-1-.32l-.29-.4a1.06,1.06,0,0,1-.13-1.26l1.45-1.54Zm2.48,2.3,1.45-1.54a1.4,1.4,0,0,0,.29-1.13,2.92,2.92,0,0,0-.56-1.4l-.29-.39a2.21,2.21,0,0,0-1.08-.84.92.92,0,0,0-1,.2l-.62.67a.54.54,0,0,0,.07.63c.16.22.39.29.51.16l.63-.67a.45.45,0,0,1,.48-.1,1.11,1.11,0,0,1,.54.42l.29.4a1.34,1.34,0,0,1,.28.69.7.7,0,0,1-.14.57L446.85,206c-.24.25-.72.1-1-.32-.16-.22-.39-.29-.51-.16a.52.52,0,0,0,.06.63,2.25,2.25,0,0,0,1.09.84.91.91,0,0,0,1-.2Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "444.44 201.2 443.08 198.96 444.02 201.6 442.85 200.95 444.35 202.7 445.03 202.04 444.45 199.41 444.44 201.2",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.45 209.17 448.81 211.41 447.87 208.76 449.04 209.42 447.54 207.66 446.86 208.32 447.43 210.96 447.45 209.17",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,160.57l-31.11-18a2.74,2.74,0,0,1-1.14-2.18V129.82c0-.84.51-1.22,1.14-.86l31.11,18a2.71,2.71,0,0,1,1.14,2.17v10.62C324.09,160.54,323.58,160.93,323,160.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.44,135.21a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v.58a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-1.69-1v1.58l1.58.92a.2.2,0,0,1,.1.12.41.41,0,0,1,.05.18v.58a.17.17,0,0,1-.05.13s-.06,0-.1,0l-1.58-.91v1.87a.17.17,0,0,1,0,.13s-.06,0-.1,0l-.43-.24a.28.28,0,0,1-.1-.13.39.39,0,0,1,0-.18V134a.17.17,0,0,1,0-.13s.06,0,.1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.31,137.67a1.83,1.83,0,0,1,.52.45,2.61,2.61,0,0,1,.41.61,3.79,3.79,0,0,1,.28.73,5.34,5.34,0,0,1,.12.77v.82a2.12,2.12,0,0,1-.13.63.82.82,0,0,1-.27.41.59.59,0,0,1-.41.15,1.09,1.09,0,0,1-.52-.17,2,2,0,0,1-.53-.44,3.25,3.25,0,0,1-.41-.61,4.22,4.22,0,0,1-.27-.73,3.34,3.34,0,0,1-.12-.77c0-.05,0-.11,0-.19v-.45c0-.07,0-.13,0-.18a1.91,1.91,0,0,1,.12-.63,1,1,0,0,1,.27-.41.61.61,0,0,1,.41-.15A1,1,0,0,1,297.31,137.67Zm.64,2.21a2.09,2.09,0,0,0-.08-.47,1.6,1.6,0,0,0-.15-.35,1.29,1.29,0,0,0-.2-.25,1.46,1.46,0,0,0-.21-.16l-.22-.09a.27.27,0,0,0-.2,0,.35.35,0,0,0-.15.18,1.12,1.12,0,0,0-.07.38.66.66,0,0,0,0,.15v.42a.76.76,0,0,0,0,.16,2,2,0,0,0,.07.46,1.27,1.27,0,0,0,.15.35,1,1,0,0,0,.2.25.82.82,0,0,0,.22.16.48.48,0,0,0,.21.09.27.27,0,0,0,.2,0,.35.35,0,0,0,.15-.18,1,1,0,0,0,.08-.37v-.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.53,140.59c-.21-.12-.36-.14-.46-.05a1,1,0,0,0-.14.63v2.12a.18.18,0,0,1,0,.13.08.08,0,0,1-.1,0l-.4-.23a.2.2,0,0,1-.1-.12.41.41,0,0,1-.05-.18v-3.8a.17.17,0,0,1,.05-.13s.06,0,.1,0l.4.24a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v.19a.52.52,0,0,1,.29-.14.77.77,0,0,1,.41.13l.24.14a.27.27,0,0,1,.1.13.41.41,0,0,1,0,.18v.53a.16.16,0,0,1,0,.13s-.06,0-.1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.14,141a.44.44,0,0,1,.31-.18.55.55,0,0,1,.38.09,1.65,1.65,0,0,1,.54.51,2.59,2.59,0,0,1,.33.69.85.85,0,0,1,.17-.2.47.47,0,0,1,.22-.09.45.45,0,0,1,.23,0,1.17,1.17,0,0,1,.24.09,1.54,1.54,0,0,1,.5.45,2.19,2.19,0,0,1,.33.6,3.2,3.2,0,0,1,.17.71,4.77,4.77,0,0,1,.05.76v2.19a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.4-.23a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18V144a2.16,2.16,0,0,0-.14-.86,1,1,0,0,0-.39-.44.3.3,0,0,0-.36,0c-.1.09-.15.3-.16.65v2.19c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.41-.23a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18V143a2,2,0,0,0-.14-.86,1,1,0,0,0-.38-.44.3.3,0,0,0-.37,0c-.11.09-.16.32-.16.68v2.15a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.4-.23a.28.28,0,0,1-.1-.13.37.37,0,0,1,0-.18v-3.79a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.4.23a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.32,144a.87.87,0,0,1,.1-.31.61.61,0,0,1,.21-.24.57.57,0,0,1,.35-.08.94.94,0,0,1,.47.16,2,2,0,0,1,.49.39,2.58,2.58,0,0,1,.37.54,3.1,3.1,0,0,1,.24.67,3.35,3.35,0,0,1,.09.79v2.39a.17.17,0,0,1-.05.13s-.06,0-.1,0l-.4-.23a.34.34,0,0,1-.1-.13.39.39,0,0,1,0-.18v-.26a.51.51,0,0,1-.32.21.74.74,0,0,1-.53-.14,1.3,1.3,0,0,1-.41-.33,1.84,1.84,0,0,1-.3-.43,2.49,2.49,0,0,1-.26-1.06c0-.38.09-.62.26-.73a.79.79,0,0,1,.7,0l.86.27a1,1,0,0,0-.15-.55,1,1,0,0,0-.35-.34.36.36,0,0,0-.21-.07.34.34,0,0,0-.14.08l-.09,0-.08,0-.5-.28a.35.35,0,0,1-.09-.11A.22.22,0,0,1,306.32,144Zm.88,2.81a.65.65,0,0,0,.32.1.33.33,0,0,0,.24-.07.46.46,0,0,0,.14-.21.94.94,0,0,0,.05-.3v-.09l-.72-.22c-.15,0-.25-.05-.31,0a.25.25,0,0,0-.1.24.54.54,0,0,0,.11.32A1,1,0,0,0,307.2,146.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.25,147.93a1.06,1.06,0,0,0,.08.45.72.72,0,0,0,.33.34l.32.19a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v.54a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.39-.22a1.94,1.94,0,0,1-.77-.81,2.93,2.93,0,0,1-.26-1.29V145.8l-.35-.2a.25.25,0,0,1-.1-.12.41.41,0,0,1-.05-.18v-.54a.17.17,0,0,1,.05-.13.08.08,0,0,1,.1,0l.35.21V143.5a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.4.23a.34.34,0,0,1,.1.13.41.41,0,0,1,.05.18v1.32l.68.4a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v.54a.17.17,0,0,1,0,.13s-.06,0-.1,0l-.68-.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "320.57 151.12 318.28 153.32 315.99 148.48 320.57 151.12",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.28,185l-31.11-18a2.76,2.76,0,0,1-1.13-2.18V154.26c0-.84.51-1.22,1.13-.86l31.11,18a2.72,2.72,0,0,1,1.14,2.17v10.62C366.42,185,365.91,185.37,365.28,185Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.77,159.65a.2.2,0,0,1,.1.12.41.41,0,0,1,.05.18v.58a.17.17,0,0,1-.05.13s-.06,0-.1,0l-1.68-1v1.58l1.58.92a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v.58a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-1.58-.92v1.87a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.43-.25a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18v-5.27a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.64,162.11a2.23,2.23,0,0,1,.53.45,3.25,3.25,0,0,1,.41.61,4.55,4.55,0,0,1,.27.73,3.52,3.52,0,0,1,.12.77v.83a2,2,0,0,1-.12.63,1,1,0,0,1-.27.41.66.66,0,0,1-.41.14,1,1,0,0,1-.53-.17,2,2,0,0,1-.52-.44,2.83,2.83,0,0,1-.41-.61,3.56,3.56,0,0,1-.28-.73,4.94,4.94,0,0,1-.12-.77v-.19a1.62,1.62,0,0,1,0-.22,1.77,1.77,0,0,1,0-.23v-.18a1.91,1.91,0,0,1,.12-.63.91.91,0,0,1,.28-.41.59.59,0,0,1,.41-.15A1.06,1.06,0,0,1,339.64,162.11Zm.64,2.21a2.12,2.12,0,0,0-.07-.47,2.29,2.29,0,0,0-.16-.35,1.26,1.26,0,0,0-.19-.25,1.12,1.12,0,0,0-.22-.16,1,1,0,0,0-.22-.09.31.31,0,0,0-.19,0,.35.35,0,0,0-.15.18,1.08,1.08,0,0,0-.08.38,1,1,0,0,1,0,.16v.41a1,1,0,0,1,0,.16,1.9,1.9,0,0,0,.08.46,1.5,1.5,0,0,0,.15.36,1,1,0,0,0,.19.24,1.63,1.63,0,0,0,.22.17.74.74,0,0,0,.22.08.25.25,0,0,0,.19,0,.41.41,0,0,0,.16-.18,1.05,1.05,0,0,0,.07-.37.71.71,0,0,0,0-.16v-.41A.76.76,0,0,0,340.28,164.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,168.82a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.4-.23a.36.36,0,0,1-.11-.13.58.58,0,0,1,0-.18v-2.07a2.31,2.31,0,0,0-.15-.86,1,1,0,0,0-.45-.56c-.19-.11-.34-.09-.44,0a1.09,1.09,0,0,0-.16.69v2.07a.17.17,0,0,1,0,.13.07.07,0,0,1-.1,0l-.4-.23a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18v-3.8a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.4.23a.2.2,0,0,1,.1.12.41.41,0,0,1,0,.18v.19a.62.62,0,0,1,.32-.17.68.68,0,0,1,.44.12,1.87,1.87,0,0,1,.54.47,2.62,2.62,0,0,1,.35.61,3.45,3.45,0,0,1,.18.72,4.77,4.77,0,0,1,.06.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.76,168.43a1.14,1.14,0,0,0,.09.46.77.77,0,0,0,.33.34l.32.18a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18v.53c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.39-.23a1.94,1.94,0,0,1-.77-.81,2.8,2.8,0,0,1-.26-1.29v-1.75l-.35-.2a.26.26,0,0,1-.11-.12.58.58,0,0,1,0-.18v-.54a.2.2,0,0,1,0-.13.09.09,0,0,1,.11,0l.35.2V164a.18.18,0,0,1,0-.13.08.08,0,0,1,.1,0l.4.23a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v1.33l.69.39a.49.49,0,0,1,.1.13.58.58,0,0,1,0,.18V167a.2.2,0,0,1,0,.13.08.08,0,0,1-.1,0l-.69-.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.9 175.56 360.61 177.76 358.32 172.92 362.9 175.56",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.61,209.45l-31.1-18a2.72,2.72,0,0,1-1.14-2.17V178.7c0-.84.51-1.22,1.14-.86l31.1,18a2.72,2.72,0,0,1,1.14,2.17v10.62C408.75,209.43,408.24,209.81,407.61,209.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379,183.36a2.36,2.36,0,0,1,.63.5,3.66,3.66,0,0,1,.45.63,3.14,3.14,0,0,1,.27.64,2.14,2.14,0,0,1,.1.56.15.15,0,0,1,0,.14.09.09,0,0,1-.1,0l-.37-.21a.4.4,0,0,1-.13-.13l-.09-.19a1.77,1.77,0,0,0-.24-.5,1.26,1.26,0,0,0-.48-.42.81.81,0,0,0-.26-.11.41.41,0,0,0-.22,0,.25.25,0,0,0-.14.13.43.43,0,0,0-.05.24.9.9,0,0,0,.05.34.92.92,0,0,0,.17.3,2.27,2.27,0,0,0,.31.34c.13.12.29.28.49.45a5.81,5.81,0,0,1,.55.57,3.19,3.19,0,0,1,.37.56,2.56,2.56,0,0,1,.22.58,2.62,2.62,0,0,1,.07.64,1.64,1.64,0,0,1-.11.62.68.68,0,0,1-.3.36.82.82,0,0,1-.48.08,2,2,0,0,1-.64-.24,2.9,2.9,0,0,1-.57-.44,3.29,3.29,0,0,1-.47-.59,3.23,3.23,0,0,1-.34-.7,2.36,2.36,0,0,1-.14-.73.14.14,0,0,1,0-.14.09.09,0,0,1,.1,0l.37.21a.44.44,0,0,1,.14.13,1.82,1.82,0,0,1,.08.19,1.43,1.43,0,0,0,.09.27,1.16,1.16,0,0,0,.14.27,1.69,1.69,0,0,0,.22.26,1.87,1.87,0,0,0,.34.25,1.66,1.66,0,0,0,.31.14.61.61,0,0,0,.26,0,.34.34,0,0,0,.18-.11.51.51,0,0,0,.06-.28.75.75,0,0,0-.07-.33,1.45,1.45,0,0,0-.22-.33c-.1-.11-.23-.23-.38-.37s-.32-.29-.51-.48a4.18,4.18,0,0,1-.46-.5,2.67,2.67,0,0,1-.33-.52,2.25,2.25,0,0,1-.19-.57,2.76,2.76,0,0,1-.07-.67,1.55,1.55,0,0,1,.11-.61.79.79,0,0,1,.29-.37.77.77,0,0,1,.44-.09A1.32,1.32,0,0,1,379,183.36Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.66,184.91a.32.32,0,0,1,.1.12.39.39,0,0,1,0,.18v.63c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.46-.26a.28.28,0,0,1-.1-.13.39.39,0,0,1,0-.18v-.63a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0Zm.11,5.63a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.4-.23a.25.25,0,0,1-.1-.12.41.41,0,0,1-.05-.18v-3.8a.17.17,0,0,1,.05-.13.08.08,0,0,1,.1,0l.4.23a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.66,191.44a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18v.53c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-2.15-1.24a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18v-.55a.3.3,0,0,1,0-.15.41.41,0,0,1,.05-.09l1.32-1.44-1.2-.7a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18v-.54a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l2,1.14a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18V189a.27.27,0,0,1,0,.13.46.46,0,0,1-.05.1l-1.32,1.45Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.2,190.61a3.2,3.2,0,0,1,.09-.8,1.34,1.34,0,0,1,.25-.55A.67.67,0,0,1,386,189a.88.88,0,0,1,.53.14,2,2,0,0,1,.54.48,2.93,2.93,0,0,1,.41.69,4.17,4.17,0,0,1,.35,1.65v.37a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-1.77-1a1.49,1.49,0,0,0,.05.36,1.83,1.83,0,0,0,.14.32,2.48,2.48,0,0,0,.19.26l.23.18a.73.73,0,0,0,.28.1.23.23,0,0,0,.17,0,.26.26,0,0,1,.1,0,.19.19,0,0,1,.1,0l.42.24a.3.3,0,0,1,.11.13.36.36,0,0,1,0,.17.52.52,0,0,1-.08.25.61.61,0,0,1-.23.22.74.74,0,0,1-.38.07,1,1,0,0,1-.52-.18,1.8,1.8,0,0,1-.53-.47,2.89,2.89,0,0,1-.42-.68,4.65,4.65,0,0,1-.25-.85A4.94,4.94,0,0,1,385.2,190.61Zm1.29-.47a.51.51,0,0,0-.26-.08.29.29,0,0,0-.18.07.57.57,0,0,0-.12.18,1.89,1.89,0,0,0-.05.23l1.2.69c0-.09,0-.18,0-.28a1.71,1.71,0,0,0-.09-.3,1.67,1.67,0,0,0-.18-.28A.93.93,0,0,0,386.49,190.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.23 200 402.94 202.21 400.66 197.36 405.23 200",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450,233.89l-31.11-18a2.72,2.72,0,0,1-1.14-2.17V203.14c0-.84.51-1.22,1.14-.86l31.11,18a2.72,2.72,0,0,1,1.13,2.18V233C451.08,233.87,450.58,234.25,450,233.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.31,207.8a2.48,2.48,0,0,1,.62.5,4.1,4.1,0,0,1,.45.63,3.14,3.14,0,0,1,.27.64,2.28,2.28,0,0,1,.11.56c0,.07,0,.12,0,.14a.11.11,0,0,1-.11,0l-.37-.21a.4.4,0,0,1-.13-.13,1.08,1.08,0,0,1-.08-.19,2.85,2.85,0,0,0-.24-.5,1.43,1.43,0,0,0-.48-.42.81.81,0,0,0-.26-.11.41.41,0,0,0-.22,0,.37.37,0,0,0-.15.13.55.55,0,0,0-.05.25,1.14,1.14,0,0,0,.05.33.92.92,0,0,0,.17.3,2.41,2.41,0,0,0,.32.34c.12.13.29.28.48.45a7.2,7.2,0,0,1,.55.57,2.71,2.71,0,0,1,.37.56,2.56,2.56,0,0,1,.22.58,2.67,2.67,0,0,1,.07.64,1.65,1.65,0,0,1-.1.62.68.68,0,0,1-.3.36.85.85,0,0,1-.49.08,1.82,1.82,0,0,1-.64-.24,3.18,3.18,0,0,1-.56-.44,3.44,3.44,0,0,1-.48-.59,3.49,3.49,0,0,1-.34-.7,2.69,2.69,0,0,1-.14-.73.18.18,0,0,1,0-.14.09.09,0,0,1,.1,0l.37.21a.44.44,0,0,1,.14.13.76.76,0,0,1,.08.2c0,.08,0,.17.09.26a1.74,1.74,0,0,0,.14.27,1.38,1.38,0,0,0,.23.26,1.78,1.78,0,0,0,.33.25,1.66,1.66,0,0,0,.31.14.63.63,0,0,0,.26,0,.34.34,0,0,0,.18-.11.41.41,0,0,0,.07-.27.94.94,0,0,0-.07-.34,1.49,1.49,0,0,0-.23-.32c-.1-.12-.23-.24-.37-.38l-.52-.48a5.23,5.23,0,0,1-.46-.5,2.85,2.85,0,0,1-.33-.52,2.73,2.73,0,0,1-.19-.57,3.4,3.4,0,0,1-.06-.67,1.56,1.56,0,0,1,.1-.61.7.7,0,0,1,.73-.46A1.36,1.36,0,0,1,421.31,207.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.34,213.8a1.14,1.14,0,0,0,.09.46.82.82,0,0,0,.33.34l.32.18a.28.28,0,0,1,.1.13.34.34,0,0,1,0,.18v.53c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.39-.23a1.94,1.94,0,0,1-.77-.81,2.93,2.93,0,0,1-.26-1.29v-1.75l-.35-.2a.28.28,0,0,1-.1-.13.37.37,0,0,1,0-.18v-.53a.16.16,0,0,1,0-.13.08.08,0,0,1,.1,0l.35.2v-1.33a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.4.23a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v1.33l.69.39a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18v.53c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.69-.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.58,216.4l-1.05-4.34s0,0,0-.06a.17.17,0,0,1,.05-.13.08.08,0,0,1,.1,0l.39.23a.38.38,0,0,1,.12.13.7.7,0,0,1,.06.17l.7,2.92.71-2.11a.15.15,0,0,1,.06-.09.08.08,0,0,1,.11,0l.4.23a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v.05l-1.49,4.45a.17.17,0,0,1-.07.1.11.11,0,0,1-.11,0l-.39-.23a.2.2,0,0,1-.1-.12.41.41,0,0,1-.05-.18s0,0,0-.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.55,218.12a.17.17,0,0,1-.05.13s-.06,0-.1,0L429,218a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18v-5.34c0-.06,0-.11,0-.13a.08.08,0,0,1,.1,0l.4.23a.24.24,0,0,1,.1.12.41.41,0,0,1,.05.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.14,216.56a3.35,3.35,0,0,1,.09-.81,1.48,1.48,0,0,1,.26-.55.63.63,0,0,1,.41-.23.91.91,0,0,1,.54.14,2,2,0,0,1,.53.48,3.07,3.07,0,0,1,.41.68,3.73,3.73,0,0,1,.26.82,3.5,3.5,0,0,1,.1.84v.37a.17.17,0,0,1-.05.13s-.06,0-.1,0l-1.76-1a1,1,0,0,0,.05.35,1.34,1.34,0,0,0,.13.32,1.06,1.06,0,0,0,.2.26.76.76,0,0,0,.23.18.69.69,0,0,0,.27.11.48.48,0,0,0,.18,0l.09,0,.1,0,.42.25a.26.26,0,0,1,.11.12.39.39,0,0,1,0,.18.66.66,0,0,1-.08.25.55.55,0,0,1-.24.21.7.7,0,0,1-.37.08,1.24,1.24,0,0,1-.52-.18,1.83,1.83,0,0,1-.54-.47,2.93,2.93,0,0,1-.41-.69,4.33,4.33,0,0,1-.26-.84A4.94,4.94,0,0,1,430.14,216.56Zm1.3-.47a.45.45,0,0,0-.27-.08.29.29,0,0,0-.18.07.42.42,0,0,0-.11.18.59.59,0,0,0-.05.23l1.19.69a1.45,1.45,0,0,0,0-.28,1.71,1.71,0,0,0-.09-.3,1.21,1.21,0,0,0-.18-.28A.87.87,0,0,0,431.44,216.09Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.81,220.16a.29.29,0,0,0,0-.16.41.41,0,0,0-.13-.18,2.69,2.69,0,0,0-.24-.24l-.39-.36a2.53,2.53,0,0,1-.39-.43,2.25,2.25,0,0,1-.24-.42,1.94,1.94,0,0,1-.14-.45,3.59,3.59,0,0,1,0-.47,1.2,1.2,0,0,1,.07-.44.62.62,0,0,1,.22-.3.53.53,0,0,1,.34-.1,1,1,0,0,1,.46.15,2.28,2.28,0,0,1,.46.36,2.38,2.38,0,0,1,.57.9,2,2,0,0,1,.09.44c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.41-.24a.25.25,0,0,1-.12-.11,1,1,0,0,1-.09-.15.94.94,0,0,0-.12-.18,1.25,1.25,0,0,0-.24-.18.6.6,0,0,0-.28-.09c-.08,0-.12.07-.12.19a.88.88,0,0,0,0,.17.69.69,0,0,0,.12.18l.22.23.38.34a2.68,2.68,0,0,1,.67.87,2.49,2.49,0,0,1,.19.93,1.14,1.14,0,0,1-.08.43.54.54,0,0,1-.23.28.5.5,0,0,1-.37.08,1.29,1.29,0,0,1-.5-.17,2.34,2.34,0,0,1-.49-.39,3.09,3.09,0,0,1-.36-.47,2.16,2.16,0,0,1-.32-.95c0-.06,0-.11,0-.13a.09.09,0,0,1,.11,0l.41.24a.25.25,0,0,1,.11.12l.09.19.14.21a1.05,1.05,0,0,0,.27.21l.17.08.15,0a.21.21,0,0,0,.12,0S434.81,220.22,434.81,220.16Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.57 224.44 445.28 226.65 442.99 221.8 447.57 224.44",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370.97,
    y: 97.54,
    width: 0.72,
    height: 194.64,
    transform: "translate(16.92 419.02) rotate(-60)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.93,55.86a.34.34,0,0,1,.1.13.41.41,0,0,1,.05.18v.57a.16.16,0,0,1-.05.13.08.08,0,0,1-.1,0l-.95-.55V60.8a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.43-.24a.34.34,0,0,1-.1-.13.39.39,0,0,1,0-.18V55.92l-1-.55a.32.32,0,0,1-.1-.12.39.39,0,0,1,0-.18v-.58c0-.06,0-.11,0-.13a.08.08,0,0,1,.1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.3,58a2,2,0,0,1,.52.44,2.67,2.67,0,0,1,.41.62,3.56,3.56,0,0,1,.28.73,3.34,3.34,0,0,1,.12.76v.83a2.26,2.26,0,0,1-.13.63.87.87,0,0,1-.27.41.64.64,0,0,1-.41.14,1,1,0,0,1-.52-.17,2,2,0,0,1-.53-.44,3,3,0,0,1-.41-.61,4.44,4.44,0,0,1-.27-.72,3.51,3.51,0,0,1-.12-.78c0-.05,0-.11,0-.18v-.46c0-.07,0-.13,0-.18a2,2,0,0,1,.12-.63,1,1,0,0,1,.27-.41.61.61,0,0,1,.41-.15A1,1,0,0,1,291.3,58Zm.64,2.2a2.09,2.09,0,0,0-.08-.47,1.6,1.6,0,0,0-.15-.35,1,1,0,0,0-.2-.24,1.57,1.57,0,0,0-.21-.17l-.22-.09a.34.34,0,0,0-.2,0,.36.36,0,0,0-.15.17,1.17,1.17,0,0,0-.07.38.71.71,0,0,0,0,.16v.41a.71.71,0,0,0,0,.16,2.12,2.12,0,0,0,.07.47,1.6,1.6,0,0,0,.15.35,1.29,1.29,0,0,0,.2.25l.22.16a1,1,0,0,0,.21.09.28.28,0,0,0,.2,0,.36.36,0,0,0,.15-.17,1.14,1.14,0,0,0,.08-.38v-.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.74,83a2.48,2.48,0,0,1,.62.5,3.32,3.32,0,0,1,.45.63,2.92,2.92,0,0,1,.27.64,2.2,2.2,0,0,1,.11.56.18.18,0,0,1,0,.14.11.11,0,0,1-.11,0l-.37-.22a.27.27,0,0,1-.13-.13.68.68,0,0,1-.08-.19,2.77,2.77,0,0,0-.24-.49,1.56,1.56,0,0,0-.48-.43,1.06,1.06,0,0,0-.26-.1.41.41,0,0,0-.22,0,.31.31,0,0,0-.15.13.54.54,0,0,0-.05.24,1.16,1.16,0,0,0,.05.34.92.92,0,0,0,.17.3,4.18,4.18,0,0,0,.31.34l.49.45a5.81,5.81,0,0,1,.55.57,2.71,2.71,0,0,1,.37.56,2.39,2.39,0,0,1,.22.58,2.62,2.62,0,0,1,.07.64,1.65,1.65,0,0,1-.1.62.69.69,0,0,1-.31.36.82.82,0,0,1-.48.08,2,2,0,0,1-.64-.24,3.18,3.18,0,0,1-.56-.44,3.51,3.51,0,0,1-.48-.6,3.4,3.4,0,0,1-.34-.69,2.69,2.69,0,0,1-.14-.73c0-.07,0-.12,0-.14a.09.09,0,0,1,.1,0l.37.21a.44.44,0,0,1,.14.13.84.84,0,0,1,.08.19c0,.09,0,.18.09.27a1.16,1.16,0,0,0,.14.27,1.92,1.92,0,0,0,.56.51,1.66,1.66,0,0,0,.31.14.63.63,0,0,0,.26,0,.34.34,0,0,0,.18-.11.43.43,0,0,0,.07-.28.73.73,0,0,0-.08-.33,1.26,1.26,0,0,0-.22-.33c-.1-.11-.23-.23-.37-.37l-.52-.48a5.23,5.23,0,0,1-.46-.5,3.24,3.24,0,0,1-.33-.52,2.73,2.73,0,0,1-.19-.57,3.48,3.48,0,0,1-.06-.67,1.65,1.65,0,0,1,.1-.62.81.81,0,0,1,.29-.36.79.79,0,0,1,.44-.09A1.36,1.36,0,0,1,288.74,83Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.82,86a.2.2,0,0,1,0-.13.08.08,0,0,1,.1,0l.41.23a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v2.07a2.47,2.47,0,0,0,.13.86,1,1,0,0,0,.45.55.3.3,0,0,0,.43,0,1.36,1.36,0,0,0,.14-.7V87a.17.17,0,0,1,0-.13s.06,0,.1,0l.4.23a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18v3.79c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.4-.23a.2.2,0,0,1-.1-.12.41.41,0,0,1,0-.18v-.19a.62.62,0,0,1-.3.16.58.58,0,0,1-.43-.1,1.74,1.74,0,0,1-.54-.46,2.8,2.8,0,0,1-.34-.61,3.2,3.2,0,0,1-.17-.71,4.87,4.87,0,0,1-.06-.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.57,88.41a1.73,1.73,0,0,1,.48.43,3,3,0,0,1,.36.64,4.27,4.27,0,0,1,.24.74,4.39,4.39,0,0,1,.1.78v.57a2.7,2.7,0,0,1-.1.67,1.38,1.38,0,0,1-.24.47.56.56,0,0,1-.36.21.68.68,0,0,1-.48-.11,2.32,2.32,0,0,1-.3-.22,2.53,2.53,0,0,1-.22-.26,1.84,1.84,0,0,1-.17-.25,2.29,2.29,0,0,1-.11-.23V92a.2.2,0,0,1,0,.13.08.08,0,0,1-.1,0l-.41-.23a.49.49,0,0,1-.1-.13.35.35,0,0,1,0-.17V86.3a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.41.24a.25.25,0,0,1,.1.12.58.58,0,0,1,0,.18v1.73a.53.53,0,0,1,.11-.09.43.43,0,0,1,.17-.06.42.42,0,0,1,.22,0A.72.72,0,0,1,295.57,88.41Zm.49,2.25a2.11,2.11,0,0,0-.21-.88,1.18,1.18,0,0,0-.44-.49.37.37,0,0,0-.44,0,.77.77,0,0,0-.2.56,2.45,2.45,0,0,0,0,.3,2.82,2.82,0,0,0,0,.31,2,2,0,0,0,.2.8,1.25,1.25,0,0,0,.44.49.39.39,0,0,0,.44,0c.12-.09.19-.3.21-.64A3.53,3.53,0,0,0,296.06,90.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.41,89.77a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.41.24a.32.32,0,0,1,.1.12.58.58,0,0,1,0,.18v4.1a1.2,1.2,0,0,1-.27.94c-.18.14-.43.12-.76-.07l-.14-.08a.25.25,0,0,1-.1-.12.39.39,0,0,1,0-.18v-.54a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.08,0c.16.09.27.1.32,0a.54.54,0,0,0,.08-.34Zm.57-1.44a.28.28,0,0,1,.1.13.38.38,0,0,1,0,.17v.64a.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.45-.26a.27.27,0,0,1-.1-.13.41.41,0,0,1-.05-.18v-.63a.16.16,0,0,1,.05-.13s.06,0,.1,0Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.69,92.41a3.23,3.23,0,0,1,.09-.81,1.41,1.41,0,0,1,.26-.55.63.63,0,0,1,.41-.23A.84.84,0,0,1,300,91a1.93,1.93,0,0,1,.53.47,3.4,3.4,0,0,1,.41.69,4.05,4.05,0,0,1,.27.81,4.17,4.17,0,0,1,.09.85v.36a.2.2,0,0,1,0,.13.08.08,0,0,1-.1,0l-1.77-1a1,1,0,0,0,.05.36,1.79,1.79,0,0,0,.13.32,1.28,1.28,0,0,0,.2.26,1.3,1.3,0,0,0,.23.18.65.65,0,0,0,.27.1.27.27,0,0,0,.18,0l.09,0a.11.11,0,0,1,.1,0l.43.24a.49.49,0,0,1,.1.13.39.39,0,0,1,0,.18.67.67,0,0,1-.08.24.69.69,0,0,1-.23.22.76.76,0,0,1-.38.07,1.09,1.09,0,0,1-.52-.17,2,2,0,0,1-.54-.47,2.93,2.93,0,0,1-.41-.69,4.23,4.23,0,0,1-.26-.85A4.83,4.83,0,0,1,298.69,92.41Zm1.3-.48a.67.67,0,0,0-.27-.08.3.3,0,0,0-.18.08.34.34,0,0,0-.11.17.64.64,0,0,0-.05.23l1.19.69a1.57,1.57,0,0,0,0-.28,1.71,1.71,0,0,0-.09-.3,1.21,1.21,0,0,0-.18-.28A1.25,1.25,0,0,0,300,91.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.42,94.28a2.27,2.27,0,0,0,0,.28,2.71,2.71,0,0,0,0,.29,3.11,3.11,0,0,0,.07.47,1.58,1.58,0,0,0,.15.37,1.52,1.52,0,0,0,.19.28,1.74,1.74,0,0,0,.22.18.73.73,0,0,0,.22.09.25.25,0,0,0,.15,0,.23.23,0,0,0,.11-.08.62.62,0,0,0,.09-.12.76.76,0,0,1,.08-.11s.06,0,.1,0l.4.23a.25.25,0,0,1,.1.12.42.42,0,0,1,0,.18,1.07,1.07,0,0,1-.08.37.74.74,0,0,1-.23.34.65.65,0,0,1-.4.15,1.12,1.12,0,0,1-.58-.19,1.83,1.83,0,0,1-.52-.45,3.18,3.18,0,0,1-.41-.64,4.78,4.78,0,0,1-.27-.75,5.26,5.26,0,0,1-.12-.78c0-.1,0-.21,0-.33s0-.23,0-.33a2.09,2.09,0,0,1,.12-.65,1,1,0,0,1,.27-.44.62.62,0,0,1,.4-.18.9.9,0,0,1,.53.16,2,2,0,0,1,.58.49,2.91,2.91,0,0,1,.4.61,2.82,2.82,0,0,1,.23.6,1.93,1.93,0,0,1,.08.46.17.17,0,0,1,0,.13.08.08,0,0,1-.1,0l-.4-.24a.2.2,0,0,1-.1-.13,1.54,1.54,0,0,1-.08-.19l-.09-.22a.78.78,0,0,0-.11-.2.9.9,0,0,0-.15-.19,1.4,1.4,0,0,0-.22-.16.63.63,0,0,0-.22-.07.26.26,0,0,0-.19.05.44.44,0,0,0-.15.21A1.52,1.52,0,0,0,302.42,94.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.84,97.12a1.14,1.14,0,0,0,.09.46.77.77,0,0,0,.33.34l.32.18a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18v.53c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.39-.23a1.94,1.94,0,0,1-.77-.81,2.93,2.93,0,0,1-.26-1.29V95l-.35-.2a.2.2,0,0,1-.1-.13.34.34,0,0,1,0-.17V94a.17.17,0,0,1,0-.13s.06,0,.1,0l.35.2V92.69a.17.17,0,0,1,0-.13.08.08,0,0,1,.1,0l.4.23a.25.25,0,0,1,.1.12.39.39,0,0,1,0,.18v1.33l.69.39a.34.34,0,0,1,.1.13.39.39,0,0,1,0,.18v.53c0,.06,0,.11,0,.13a.08.08,0,0,1-.1,0l-.69-.39Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,249.19a1,1,0,0,1-.5-.13L296,162.28a1,1,0,0,1-.36-1.37,1,1,0,0,1,1.36-.36l150.3,86.77a1,1,0,0,1-.5,1.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,258.44a1,1,0,0,1-.5-.13L296,171.53a1,1,0,0,1,1-1.73l150.3,86.77a1,1,0,0,1-.5,1.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,267.69a1,1,0,0,1-.5-.13L296,180.78a1,1,0,0,1,1-1.73l150.3,86.77a1,1,0,0,1-.5,1.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,276.94a1,1,0,0,1-.5-.13L296,190a1,1,0,0,1,1-1.73l150.3,86.77a1,1,0,0,1-.5,1.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,286.19a1,1,0,0,1-.5-.13L296,199.28a1,1,0,0,1,1-1.73l150.3,86.78a1,1,0,0,1,.37,1.36A1,1,0,0,1,446.81,286.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,295.44a1,1,0,0,1-.5-.13L296,208.53a1,1,0,0,1,1-1.73l150.3,86.78a1,1,0,0,1,.37,1.36A1,1,0,0,1,446.81,295.44Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,304.69a1,1,0,0,1-.5-.13L296,217.79a1,1,0,0,1,1-1.74l150.3,86.78a1,1,0,0,1,.37,1.36A1,1,0,0,1,446.81,304.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.81,313.94a1,1,0,0,1-.5-.13L296,227a1,1,0,0,1,1-1.74l150.3,86.78a1,1,0,0,1,.37,1.36A1,1,0,0,1,446.81,313.94Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.65,20.33c0-2.46,1.75-3.45,3.89-2.22l177.6,102.47a8.63,8.63,0,0,1,3.89,6.75v12.74l-185.38-107Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M456,124.39c-1.16-.67-2.09-.13-2.09,1.21a4.6,4.6,0,0,0,2.09,3.62c1.16.67,2.09.13,2.09-1.21A4.6,4.6,0,0,0,456,124.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.62,119.55c-1.15-.67-2.09-.12-2.09,1.21a4.64,4.64,0,0,0,2.09,3.63c1.16.67,2.1.12,2.1-1.21A4.63,4.63,0,0,0,447.62,119.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.25,114.72c-1.16-.67-2.09-.13-2.09,1.21a4.61,4.61,0,0,0,2.09,3.62c1.16.67,2.09.13,2.09-1.21A4.6,4.6,0,0,0,439.25,114.72Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,137.16V124.5a8,8,0,0,0-1.18-3.89l-5,2.85a7.83,7.83,0,0,1,1.17,3.87v12.74Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,137.16V124.5a8,8,0,0,0-1.18-3.89l-5,2.85a7.83,7.83,0,0,1,1.17,3.87v12.74Z",
    style: {
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.54,18.11,460.13,120.58a8.06,8.06,0,0,1,2.75,2.89l4.95-2.86a7.81,7.81,0,0,0-2.71-2.84L287.52,15.29a2.76,2.76,0,0,0-2.83-.23c-.7.43-3.94,2.27-4.76,2.71A2.83,2.83,0,0,1,282.54,18.11Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.54,18.11,460.13,120.58a8.06,8.06,0,0,1,2.75,2.89l4.95-2.86a7.81,7.81,0,0,0-2.71-2.84L287.52,15.29a2.76,2.76,0,0,0-2.83-.23c-.7.43-3.94,2.27-4.76,2.71A2.83,2.83,0,0,1,282.54,18.11Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-icon--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-tool--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M218.16,49V71.66l2.06,1.15V65.66c0-3.86,3.14-5.17,7-2.93l9.63,5.55V109.2c0,4.47-2.74,6.52-6.12,4.57l-6-3.45-.06,0-6.55,3.78L250.9,133l4.43-2.55,2.12,1.23v-2.46l-6-3.48c-3.38-1.95-6.12-7.16-6.12-11.63V73.16l9.63,5.56c3.87,2.24,7,7.17,7,11V96.9L264,98.13V75.44Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.16,49V71.66l2.06,1.15V65.66c0-3.86,3.14-5.17,7-2.93l9.63,5.55V109.2c0,4.47-2.74,6.52-6.12,4.57l-6-3.45-.06,0-6.55,3.78L250.9,133l4.43-2.55,2.12,1.23v-2.46l-6-3.48c-3.38-1.95-6.12-7.16-6.12-11.63V73.16l9.63,5.56c3.87,2.24,7,7.17,7,11V96.9L264,98.13V75.44Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.67 76.59 220.22 72.81 220.22 61.51 213.67 62.75 213.67 76.59",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61,52.75V75.44l2.06,1.15V69.44c0-3.86,3.14-5.17,7-2.93l9.63,5.56V113c0,4.48-2.74,6.52-6.12,4.57l-6-3.48v2.46l32.74,18.9V133l-6-3.48c-3.38-2-6.12-7.16-6.12-11.63V76.94l9.63,5.56c3.87,2.24,7,7.18,7,11v7.16l2.06,1.22V79.23Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.61,52.75V75.44l2.06,1.15V69.44c0-3.86,3.14-5.17,7-2.93l9.63,5.56V113c0,4.48-2.74,6.52-6.12,4.57l-6-3.48v2.46l32.74,18.9V133l-6-3.48c-3.38-2-6.12-7.16-6.12-11.63V76.94l9.63,5.56c3.87,2.24,7,7.18,7,11v7.16l2.06,1.22V79.23Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.16 48.97 211.6 52.76 257.45 79.22 264 75.44 218.16 48.97",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.16 48.97 211.6 52.76 257.45 79.22 264 75.44 218.16 48.97",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264 75.44 257.45 79.22 257.45 101.91 264 98.13 264 75.44",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "264 75.44 257.45 79.22 257.45 101.91 264 98.13 264 75.44",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.45 129.19 250.91 132.97 250.91 135.43 257.45 131.65 257.45 129.19",
    style: {
      fill: "#8E4DFE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-2--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dropdown-menu--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--dropdown-menu--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M206.48,148.89a2,2,0,0,1,.85-1.87l5.41-3.12a2,2,0,0,1,2,.19l45.94,26.52,2.89,1.67v36.77a2,2,0,0,1-.83,1.86c-.53.32-4.93,2.85-5.46,3.15a2,2,0,0,1-2-.2l-46-26.51a6.37,6.37,0,0,1-2.89-5Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.74,143.9a2.06,2.06,0,0,1,2.06.19l57.39,33.14a1.29,1.29,0,0,1,0,2.24,56.07,56.07,0,0,1-5.74,3.26l-8.24,2.08v-9.4l-48.83-28.19a2.05,2.05,0,0,0-2-.2Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.74,143.9a2.06,2.06,0,0,1,2.06.19l57.39,33.14a1.29,1.29,0,0,1,0,2.24,56.07,56.07,0,0,1-5.74,3.26l-8.24,2.08v-9.4l-48.83-28.19a2.05,2.05,0,0,0-2-.2Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.59,213.58a1.93,1.93,0,0,1-.95-.3l-45.95-26.51a5.74,5.74,0,0,1-2.56-4.43l0-33.45a1.43,1.43,0,0,1,.51-1.29.82.82,0,0,1,.42-.1,2,2,0,0,1,1,.3l57.38,33.14a.59.59,0,0,1,.32.54.63.63,0,0,1-.31.54l-.17.07-8.74,2.2v27.9a1.42,1.42,0,0,1-.52,1.29A.82.82,0,0,1,256.59,213.58Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.09,148.16a1.39,1.39,0,0,1,.62.22l48.82,28.19,8.48,4.89-8.14,2-1,.26v28.42c0,.5-.14.69-.18.71a.14.14,0,0,1-.09,0,1.43,1.43,0,0,1-.62-.22L210,186.2a5.11,5.11,0,0,1-2.22-3.85l0-33.46c0-.5.15-.69.18-.71a.17.17,0,0,1,.09,0m0-1.33a1.44,1.44,0,0,0-.75.19,2,2,0,0,0-.85,1.87l0,33.45a6.4,6.4,0,0,0,2.89,5l46,26.51a2.74,2.74,0,0,0,1.29.39,1.44,1.44,0,0,0,.75-.19,2,2,0,0,0,.86-1.87V184.81l8.24-2.08a1.2,1.2,0,0,0,.33-.13,1.3,1.3,0,0,0,0-2.24l-8.57-5-48.82-28.19a2.67,2.67,0,0,0-1.29-.39Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M220,183.53a2.31,2.31,0,0,1-.17-.95V165.32a1.17,1.17,0,0,1,.17-.76c.11-.11.27-.1.5,0l5.34,3.08a.94.94,0,0,1,.4.56,4.18,4.18,0,0,1,.12,1.13v.87a2.66,2.66,0,0,1-.12,1c-.09.18-.22.21-.4.11l-3.18-1.84v4l2.82,1.63a.94.94,0,0,1,.4.56,4.18,4.18,0,0,1,.12,1.13v.87a2.66,2.66,0,0,1-.12,1,.26.26,0,0,1-.4.11l-2.82-1.63v4.51l3.2,1.85a.9.9,0,0,1,.39.55,4.71,4.71,0,0,1,.11,1.13v.86a3,3,0,0,1-.11,1c-.08.18-.21.22-.39.11l-5.36-3.09A1.16,1.16,0,0,1,220,183.53Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.05,188.34a12.08,12.08,0,0,1-1-3.14,23.52,23.52,0,0,1-.36-4.31,11.41,11.41,0,0,1,.8-5,1.42,1.42,0,0,1,2.22-.66,4,4,0,0,1,1.49,1.67v-6.13c0-.59.36-.68,1.08-.26l.51.29a1.79,1.79,0,0,1,1.08,1.52v15.2c0,.86,0,1.52.05,2s.07,1,.12,1.54a6.29,6.29,0,0,1,0,.65c0,.29-.24.38-.73.24a5.27,5.27,0,0,1-1.3-.52,1.13,1.13,0,0,1-.49-.75,13.53,13.53,0,0,1-.25-1.43,1.62,1.62,0,0,1-.78.95,1.14,1.14,0,0,1-1.13-.11A3.83,3.83,0,0,1,229.05,188.34Zm3.2-1.76V179.7a2.34,2.34,0,0,0-.75-.82c-.36-.21-.62,0-.79.53a12.74,12.74,0,0,0-.25,3.13,18.79,18.79,0,0,0,.21,3.27,2,2,0,0,0,.69,1.37C231.71,187.38,232,187.18,232.25,186.58Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.77,192.62v-12.9c0-.59.36-.68,1.08-.26l.51.29a1.8,1.8,0,0,1,1.09,1.52v12.89c0,.6-.37.68-1.09.27l-.51-.3A1.78,1.78,0,0,1,236.77,192.62Zm.13-16.08v-1.68c0-.59.4-.65,1.21-.19s1.26,1,1.26,1.63V178c0,.59-.4.65-1.21.19S236.9,177.13,236.9,176.54Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,195.65a9.58,9.58,0,0,1-.59-3.62v-7.18l-.2-.12a.93.93,0,0,1-.41-.57,3.76,3.76,0,0,1-.13-1.13v-.48a2.41,2.41,0,0,1,.13-1c.08-.17.22-.21.41-.09l.2.11.24-2.51c.06-.56.38-.67,1-.33l.56.33a1.58,1.58,0,0,1,.9,1.41v2.65l.67.38a1,1,0,0,1,.42.58,4.18,4.18,0,0,1,.12,1.13v.47a2.72,2.72,0,0,1-.12,1q-.14.26-.42.09l-.67-.39v7.3a2.52,2.52,0,0,0,.1.8.81.81,0,0,0,.33.43,1.05,1.05,0,0,0,.25.08.67.67,0,0,1,.24.09c.15.08.27.42.38,1a8.15,8.15,0,0,1,.17,1.28c0,.46-.21.69-.62.69a2.7,2.7,0,0,1-1.27-.39A4,4,0,0,1,242,195.65Z",
    style: {
      fill: "#8E4DFE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble-1--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.46,130.4,97.35,98.05a7,7,0,0,1,6.32,0l.7.42a7,7,0,0,1,3.16,5.47v29.83c0,2,0,3.64-2.87,5.26L48.47,171.6a7,7,0,0,1-6.32,0l-.69-.42a7,7,0,0,1-3.16-5.48V135.88A7,7,0,0,1,41.46,130.4Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.16,149c-2.86-1.37-6-4.9-6-8.56l-8.76,5.15A15.44,15.44,0,0,0,104,150.55.81.81,0,0,0,104.16,149Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,103.05c-.37-1.35-1.59-1.77-3-.93l-55.9,32.36a6.25,6.25,0,0,0-2.23,2.35l-7-4.06a6.44,6.44,0,0,1,2.23-2.36L97.35,98.05a7,7,0,0,1,6.32,0l.7.42A7,7,0,0,1,107.42,103.05Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.42,103.05c-.37-1.35-1.59-1.77-3-.93l-55.9,32.36a6.25,6.25,0,0,0-2.23,2.35l-7-4.06a6.44,6.44,0,0,1,2.23-2.36L97.35,98.05a7,7,0,0,1,6.32,0l.7.42A7,7,0,0,1,107.42,103.05Z",
    style: {
      fill: "#fff",
      opacity: 0.45
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,165.7a7,7,0,0,0,3.16,5.48l.69.42a7,7,0,0,0,5.78.26c-1.49.56-2.62-.29-2.62-2.09V140a6.48,6.48,0,0,1,.92-3.12l-7-4.07a6.51,6.51,0,0,0-.92,3.12Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3,165.7a7,7,0,0,0,3.16,5.48l.69.42a7,7,0,0,0,5.78.26c-1.49.56-2.62-.29-2.62-2.09V140a6.48,6.48,0,0,1,.92-3.12l-7-4.07a6.51,6.51,0,0,0-.92,3.12Z",
    style: {
      fill: "#fff",
      opacity: 0.25
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.79,102.69c.13,0,.5,0,.67.63h0a3.63,3.63,0,0,1,.06.64v29.82c0,1.9,0,3-2.37,4.39L98,141.75l-.7.4.24.77a12.61,12.61,0,0,0,5.69,6.75,14.82,14.82,0,0,1-11.75-3.35l-.54-.48-.63.36-7.14,4.15-10.53,6.11L48,170.73a4.11,4.11,0,0,1-.42.21h0l-.07,0a1.29,1.29,0,0,1-.37.06c-.65,0-.75-.79-.75-1.25V139.94a5.55,5.55,0,0,1,.8-2.62,5.25,5.25,0,0,1,1.86-2L104.88,103a1.81,1.81,0,0,1,.91-.3m0-1a2.91,2.91,0,0,0-1.41.43l-55.9,32.35a6.28,6.28,0,0,0-2.23,2.36,6.49,6.49,0,0,0-.93,3.11v29.84c0,1.42.71,2.25,1.75,2.25a2.19,2.19,0,0,0,.65-.1.81.81,0,0,0,.22-.07c.19-.08.37-.17.54-.26l24.64-14.27,10.53-6.12,7.15-4.14A15.39,15.39,0,0,0,101,150.83a15.84,15.84,0,0,0,3-.28.81.81,0,0,0,.19-1.51,11.53,11.53,0,0,1-5.69-6.43l6.19-3.59c2.84-1.6,2.87-3.24,2.87-5.25V104a5.17,5.17,0,0,0-.26-1.58,6,6,0,0,1,.15.68,1.66,1.66,0,0,0-1.63-1.36Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M55.7,148.31a8.82,8.82,0,0,1,.31-2.24,11.08,11.08,0,0,1,.85-2.18A9.49,9.49,0,0,1,58.12,142a6.29,6.29,0,0,1,1.56-1.31,3.24,3.24,0,0,1,1.55-.49,2,2,0,0,1,1.27.41,2.62,2.62,0,0,1,.84,1.19,5.15,5.15,0,0,1,.31,1.9,8.47,8.47,0,0,1-.31,2.25,10.38,10.38,0,0,1-.84,2.17A10,10,0,0,1,61.23,150a6.25,6.25,0,0,1-1.55,1.31,3.28,3.28,0,0,1-1.56.49,2,2,0,0,1-1.26-.4,2.8,2.8,0,0,1-.85-1.2A5.32,5.32,0,0,1,55.7,148.31Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.24,139.35a8.82,8.82,0,0,1,.3-2.25,11.08,11.08,0,0,1,.85-2.18,10,10,0,0,1,1.27-1.86,6.25,6.25,0,0,1,1.55-1.31,3.28,3.28,0,0,1,1.56-.49,2,2,0,0,1,1.26.41,2.71,2.71,0,0,1,.85,1.19,5.36,5.36,0,0,1,.31,1.9,8.83,8.83,0,0,1-.31,2.25,11,11,0,0,1-.85,2.17A9.49,9.49,0,0,1,76.77,141a6.08,6.08,0,0,1-1.56,1.31,3.24,3.24,0,0,1-1.55.49,2.09,2.09,0,0,1-1.27-.4,2.8,2.8,0,0,1-.85-1.2A5.32,5.32,0,0,1,71.24,139.35Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.77,130.38a8.41,8.41,0,0,1,.31-2.25,10.49,10.49,0,0,1,.85-2.18,9.49,9.49,0,0,1,1.26-1.86,6.29,6.29,0,0,1,1.56-1.31,3.12,3.12,0,0,1,1.55-.48,2,2,0,0,1,1.27.4,2.62,2.62,0,0,1,.84,1.19,5.15,5.15,0,0,1,.31,1.9,8.41,8.41,0,0,1-.31,2.25,10.11,10.11,0,0,1-2.11,4,6.2,6.2,0,0,1-1.55,1.3,3.28,3.28,0,0,1-1.56.49,2,2,0,0,1-1.26-.4,2.66,2.66,0,0,1-.85-1.2A5.06,5.06,0,0,1,86.77,130.38Z",
    style: {
      fill: "#8E4DFE"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chair--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.92,343.17c.21-2.72-1.94-5.82-6.73-9.49-8.83-6.78-40.92-29.1-53.39-37.36a.14.14,0,0,0-.1-.12c-9.54-6.89-11.69-54.09-16.88-76.68a41.42,41.42,0,0,0-1.13-4.16c0-.11-.07-.2-.1-.31-.11-.3-.21-.61-.33-.93-.06-.15-.11-.31-.16-.46h0a21.46,21.46,0,0,0-4.1-7.07,10.39,10.39,0,0,0-2.15-1.78c-1.08-.72-3.71-2-4.27-2.43-6.49-4.62-23,7.1-34.59,12.32-7.24,3.24-13.51,7.29-17.78,15.42h0A48.83,48.83,0,0,0,57.55,245C55.63,256.53,56,295.24,57,312.25h0C58.2,340.62,62.39,341,68.1,346.19c9.83,8.93,38.69,27.19,48.32,31.9,17.47,8.53,33.08-1.23,44.5-5.78s33.05-15.15,38-18.14c2.9-1.78,4.48-3.69,4.63-5.82C203.55,347.51,203.85,344.06,203.92,343.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.34,367.08c11.41-4.55,33-15.15,37.94-18.14,6.61-4,6.41-8.73-2.09-15.26-11.8-9.06-60.23-41.89-60.23-41.89s-56.3,27.13-69.64,39c-2,1.79-2.1,5.58-1.4,6.46,7.31,9.14,39.87,30.24,50.92,35.63C134.31,381.39,149.92,371.63,161.34,367.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.84,204.81l-.18-.11a10,10,0,0,0-4.83-1.5c-5.9-.48-15.22,3.65-29.17,12.66a76.83,76.83,0,0,0-12,9.14c-.07.07-.15.14-.21.21a27.29,27.29,0,0,0-3.06,3.42c-.16.2-.31.4-.46.61s-.18.23-.25.35l-.57.83c-.36.57-.72,1.16-1.07,1.77l-.11.19-.4.75h0l-4.34-3C66.47,222,73,217.81,79.78,213.66c11.63-7.13,24.59-16.4,32.84-12.4C113.25,201.56,117.76,204.09,118.84,204.81Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.82,219.52c-.75-3-3.36-15.81-13-16.33-5.9-.47-15.22,3.66-29.17,12.67-6.49,4.2-14,9.57-17.69,16.52C61.5,241,60.65,265,61,288s1.81,45.17,4.93,49.24c5.48-15.36,70.22-45.62,77.8-41.05C134.16,289.31,132,242.11,126.82,219.52Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bottom--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.51,291.34c-.87,13-1.11,30,.43,36.26,1.88,7.7,6.57,17.15,21.27,25.8,20.92,12.31,35.46,20.47,35.46,20.47l69.27-45.13L161.6,299.42Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.51,291.34c-.87,13-1.11,30,.43,36.26,1.88,7.7,6.57,17.15,21.27,25.8,20.92,12.31,35.46,20.47,35.46,20.47l69.27-45.13L161.6,299.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109,339.39c-.56-.61-1.1-1.22-1.63-1.83,5.22-1.38,8.29-7.86,7.64-15.18a64.77,64.77,0,0,1-.23-13.46l-.91-.12a64.57,64.57,0,0,0,.23,13.66c.65,7.38-2.46,13.35-7.4,14.31-10-12-8.44-23.59-3.57-39l-.88-.28c-5.34,16.92-6.15,29.33,6.08,42.55,8,8.68,30,20.55,42.77,28.45l.86-.55C139.17,360.05,117.05,348.1,109,339.39Z",
    style: {
      opacity: 0.35000000000000003
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,314.6a27.39,27.39,0,0,1-8.59,13.26c10.85,7.9,19.75,15.24,26,20.63l7.6-4.87-26.67-17.9C166.33,319.36,164.92,314.6,164.92,314.6Z",
    style: {
      opacity: 0.35000000000000003
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-431"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "212.32 465.88 74.47 386.3 292.05 260.74 429.9 340.32 212.32 465.88",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.32 465.88 74.47 386.3 292.05 260.74 429.9 340.32 212.32 465.88",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.47 386.3 74.47 396.25 212.32 475.83 212.32 465.88 74.47 386.3",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.47 386.3 74.47 396.25 212.32 475.83 212.32 465.88 74.47 386.3",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.32 475.83 429.9 350.27 429.9 340.32 212.32 465.88 212.32 475.83",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.32 465.88 429.9 340.32 429.9 350.27 212.32 475.83 212.32 465.88",
    style: {
      fill: "#fff",
      opacity: 0.65
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Laptop--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pot--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223.14,433.7c7.63,4.41,7.63,11.55,0,15.95s-20,4.41-27.63,0-7.63-11.54,0-15.95S215.51,429.3,223.14,433.7Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M197.18,442.66c-6.65-6.78-10.55-23.71-4.07-29.08h33c6.47,5.37,2.58,22.29-4.07,29.08l-.18.18c-.07.08-.15.15-.23.23a6.29,6.29,0,0,1-.6.53l-.16.12c-.16.13-.32.26-.5.38a8.89,8.89,0,0,1-.86.55c-5.46,3.16-14.32,3.16-19.79,0h0a8.89,8.89,0,0,1-.86-.55l-.47-.35-.2-.16c-.2-.17-.4-.34-.58-.51l-.26-.26A1.14,1.14,0,0,1,197.18,442.66Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.22,411.41c7.53,4.34,7.53,11.39,0,15.73s-19.72,4.34-27.25,0-7.52-11.39,0-15.73S215.7,407.07,223.22,411.41Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.89,414.49c4.57,2.64,4.57,6.93,0,9.57s-12,2.64-16.58,0-4.58-6.93,0-9.57S213.31,411.85,217.89,414.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.31,419c4.58-2.64,12-2.64,16.58,0a7.69,7.69,0,0,1,2.74,2.52,7.67,7.67,0,0,1-2.74,2.51c-4.58,2.64-12,2.64-16.58,0a7.58,7.58,0,0,1-2.74-2.51A7.6,7.6,0,0,1,201.31,419Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.88,421.55a37.94,37.94,0,0,0,6-8c2.77-4.9,5.14-11.12,3.71-11.93s-9.12,5.39-9.12,5.39a35.46,35.46,0,0,0,.62-8.35c-.25-4.36-1.31-8.33-2.56-9.13s-4,4.71-5.24,8.69-1.68,6.47-1.68,6.47-1-4.59-2.38-8.38c-1.46-4.14-2.77-5.07-3.8-4.66s-1.69,2.34-2,7.85a55,55,0,0,0,.24,7.89s-2-2.26-4.33-4.45c-2.51-2.41-4.28-2.4-5-1.94s-.22,3.86,3.66,10.88a39.46,39.46,0,0,0,7.32,9.64S207.7,425,216.88,421.55Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M216.88,421.55a37.94,37.94,0,0,0,6-8c2.77-4.9,5.14-11.12,3.71-11.93s-9.12,5.39-9.12,5.39a35.46,35.46,0,0,0,.62-8.35c-.25-4.36-1.31-8.33-2.56-9.13s-4,4.71-5.24,8.69-1.68,6.47-1.68,6.47-1-4.59-2.38-8.38c-1.46-4.14-2.77-5.07-3.8-4.66s-1.69,2.34-2,7.85a55,55,0,0,0,.24,7.89s-2-2.26-4.33-4.45c-2.51-2.41-4.28-2.4-5-1.94s-.22,3.86,3.66,10.88a39.46,39.46,0,0,0,7.32,9.64S207.7,425,216.88,421.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M210.28,398.25c-1.2,4-1.68,6.47-1.68,6.47h0l.73,3.43s.75-7.51,1.81-12.34C210.81,396.64,210.51,397.48,210.28,398.25Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202,404.27a49.14,49.14,0,0,1-1.06-9.56,37.8,37.8,0,0,0-.5,4.82,55,55,0,0,0,.24,7.89L206,413A47.26,47.26,0,0,1,202,404.27Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.12,410.3l3.34-3.26h0a35.46,35.46,0,0,0,.62-8.35,29.45,29.45,0,0,0-.68-4.94,23,23,0,0,1-.39,8A74.53,74.53,0,0,1,214.12,410.3Z",
    style: {
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Computer--inject-431"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mouse--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168.87,386.1c0-.13,0-.27,0-.4a.13.13,0,0,1,0-.06c-.39-10.55-14.16-20.42-25.84-22.38-11.85-2-18.85,6.52-18.85,11.94l0,0c-.27,4,3.48,8.57,10.66,12.16,11,5.53,24.88,7.2,30.9,3.73a5.64,5.64,0,0,0,3.09-5Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.2,383.67c0-.13,0-.25,0-.38v-.06c-.38-10.06-13.5-19.46-24.64-21.33-11.3-1.9-18,6.21-18,11.38l0,0c-.25,3.77,3.32,8.16,10.17,11.59,10.54,5.28,23.73,6.87,29.46,3.55a5.34,5.34,0,0,0,3-4.78Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.21,370.63c-10.57,2.58-15.71,11.69-17.3,17.5l1.15.32c1.54-5.66,6.62-14.65,17.18-16.85C161.91,371.27,161.57,371,161.21,370.63Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.54,387.5a15.53,15.53,0,0,0-10.32-14.65l-.41,1.12a14.18,14.18,0,0,1,9.54,14.41A6.93,6.93,0,0,0,166.54,387.5Z",
    style: {
      fill: "#8E4DFE"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Keyboard--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    id: "freepik--shadow--inject-431",
    d: "M164.55,361.66l32.69,18.95a3.92,3.92,0,0,0,3.56,0l93.81-54.08a1.09,1.09,0,0,0,0-2.06l-32.68-19a3.92,3.92,0,0,0-3.56,0l-93.81,54.09A1.08,1.08,0,0,0,164.55,361.66Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--keyboard--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M290.79,321.68a1.23,1.23,0,0,0-.72-1l-29.25-16.88a3.84,3.84,0,0,0-3.48,0l-89.23,51.6a1.23,1.23,0,0,0-.72,1v3.06a1.22,1.22,0,0,0,.73,1l29.22,16.88a3.87,3.87,0,0,0,3.49,0l89.24-51.51a1.22,1.22,0,0,0,.72-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.34,374.2l-29.22-16.8a1.06,1.06,0,0,1,0-2l89.23-51.6a3.84,3.84,0,0,1,3.48,0l29.25,16.88a1.06,1.06,0,0,1,0,2L200.83,374.2A3.84,3.84,0,0,1,197.34,374.2Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199,374.62v3.13a3.45,3.45,0,0,1-1.63-.4l-29.22-16.88a1.22,1.22,0,0,1-.72-1v-3.08a1.24,1.24,0,0,0,.72,1l29.22,16.81A3.7,3.7,0,0,0,199,374.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.87,306.45l.06,0,2.9,1.67-3.93,2.26-3-1.68,3.92-2.26Zm4.53,2.62h.06l2.9,1.67-3.09,1.78-3-1.68,3.08-1.78Zm-10,.55h.07l2.89,1.67-3.08,1.78-3-1.68,3.07-1.78Zm14.55,2.07H268l2.9,1.67-5,2.87-3-1.68,5-2.87Zm-9.17.06h.06l2.89,1.67-2.44,1.42-3-1.69,2.45-1.41Zm-10,.55h.07L251.7,314l-3.08,1.78-3-1.68,3.07-1.78Zm6,1.76.06,0,2.9,1.67-2.45,1.41-3-1.68,2.44-1.41Zm17.71.24h.06l2.9,1.67-3.93,2.27-3-1.68,3.92-2.27ZM244.1,315h.06l2.9,1.67-22.28,12.87-3-1.69L244.06,315Zm17.29.48h.06l2.9,1.67-2.45,1.42-3-1.68,2.44-1.42Zm-10.65.92h.07l2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm26.25.54h.06l2.9,1.67L277.5,320l-3-1.68,2.45-1.41Zm-10,.55H267l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-9.59.31h.07l2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm-10.65.91h.07l2.89,1.67-2.45,1.42-3-1.68,2.44-1.41Zm26.25.54h.07l2.89,1.67-2.45,1.42-3-1.68,2.44-1.42Zm-10,.55H263l2.89,1.67-2.45,1.42-3-1.68,2.45-1.42Zm-9.59.31h.06l2.9,1.67-2.45,1.42-3-1.69,2.44-1.41Zm29.12,0h.06l2.9,1.67-3.09,1.78-3-1.68,3.08-1.78Zm-39.77.92h.07l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm26.25.54H269l2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm-10,.55H259l2.9,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-9.59.3a.1.1,0,0,1,.07,0l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-10.65.92h.07l2.89,1.67-2.45,1.42-3-1.68,2.45-1.42Zm37.39.46h.07l2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm-11.14.08H265l2.89,1.67L265.47,327l-3-1.69,2.45-1.41Zm-10,.55H255l2.9,1.67-2.45,1.42-3-1.68,2.45-1.42Zm-9.6.31h.07l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-10.65.91a.1.1,0,0,1,.07,0l2.9,1.67-2.46,1.41-3-1.68,2.45-1.41Zm37.39.46h.07l2.89,1.67-2.45,1.42-3-1.68,2.45-1.42Zm-11.13.08H261l2.89,1.68-2.45,1.41-3-1.68,2.45-1.41Zm-10,.55.06,0,2.9,1.67-2.45,1.41-3-1.68,2.44-1.41Zm-9.59.31h.06l2.89,1.68-2.45,1.41-3-1.68,2.45-1.41ZM230.7,328h.06l2.9,1.67-2.45,1.42-3-1.69,2.44-1.41Zm37.38.46h.07l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-11.13.08H257l2.9,1.67-2.46,1.41-3-1.68,2.45-1.41Zm-36.69.25.06,0,2.9,1.67-3.08,1.78-3-1.69,3.08-1.77Zm26.67.3H247l2.89,1.67-2.45,1.42-3-1.69,2.44-1.41Zm-9.59.31h.06l2.9,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-10.65.91.07,0,2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm37.39.46h.06L267,332.4l-2.44,1.42-3-1.69,2.45-1.41Zm-11.14.08H253l2.9,1.67-2.45,1.42-3-1.68,2.45-1.41Zm-10,.55H243l2.89,1.68-2.45,1.41-3-1.68,2.45-1.41Zm-27.3.07.07,0,2.89,1.67-3.08,1.78-3-1.69,3.08-1.77Zm17.71.24h.07l2.89,1.67-2.45,1.42-3-1.69,2.44-1.41Zm-10.65.92h.07l2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm26.25.54H249l2.9,1.67-2.45,1.41-3-1.68,2.44-1.41Zm-10,.55H239l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-9.59.3.07,0,2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm29,.07h.07l2.89,1.67-2.45,1.42-3-1.68,2.45-1.42ZM211,334.1H211l2.9,1.68-3.09,1.78-3-1.69,3.08-1.77Zm7.69.79h.07l2.89,1.67L219.18,338l-3-1.68,2.45-1.42Zm26.25.54H245l2.89,1.67-2.45,1.42-3-1.69,2.44-1.41Zm-10,.55H235l2.9,1.67-2.46,1.42-3-1.68,2.45-1.42Zm-9.6.31h.07l2.89,1.67-2.45,1.42-3-1.69,2.45-1.41Zm29,.07h.06l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-48,.42h.06l2.9,1.68-3.93,2.26-3-1.68,3.92-2.26Zm8.32.43h.07l2.89,1.67-7.72,4.46-3-1.68,7.72-4.46Zm26.25.53a.1.1,0,0,1,.07,0l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-10,.56H231l2.9,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-9.59.3h.06l2.89,1.68-2.45,1.41-3-1.68,2.45-1.41Zm29,.07h.06l2.9,1.67-2.45,1.42-3-1.69,2.45-1.41Zm-13.4,1.39H237l2.89,1.67-2.45,1.42-3-1.69,2.45-1.41Zm-36.9.38h.06l2.9,1.67-2.45,1.41-3-1.68,2.45-1.41Zm26.88.17H227l2.9,1.67-2.45,1.42-3-1.69,2.44-1.41Zm-9.59.31h.06l2.89,1.67L218,343.89a.46.46,0,0,0-.25.41.5.5,0,0,0,.26.43l3.8,2.19L219,348.58l-7.52-4.3,5.82-3.36Zm29,.06.06,0,2.9,1.67-2.45,1.41-3-1.68,2.44-1.41Zm-13.4,1.39H233l2.89,1.67-2.45,1.42-3-1.68,2.45-1.41Zm-36.9.38h.06l2.9,1.67-2.45,1.42-3-1.69,2.44-1.41Zm26.88.17.07,0,2.89,1.67L223.39,346l-3-1.68,2.44-1.41Zm17.67,1.39h.06l2.9,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-11.66.38H229l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-36.9.37.07,0,2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm8.54.31h.07l2.89,1.67L201,348.46l-3-1.68,2.44-1.41Zm36,1.25h.06l2.9,1.67-2.45,1.42-3-1.69,2.44-1.41Zm-11.66.38H225l2.89,1.67-4.35,2.51-3-1.68,4.34-2.51Zm-37.74.87h.06l2.9,1.67-6.46,3.73-3-1.68,6.45-3.73Zm26.46.41.07,0,2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm18.93.65.06,0,2.9,1.67L233,352l-3-1.68,2.44-1.41Zm-40.86,1.55h.07l2.89,1.67-2.45,1.42-3-1.68,2.44-1.42Zm17.92.12h.07l2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm8.54.3h.06l2.9,1.67L218.64,354l-3-1.69,2.44-1.41Zm10.39.35h.07l2.89,1.67L229,354.34l-3-1.68,2.44-1.41Zm-49.4,1.24a.1.1,0,0,1,.07,0l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm8.54.31h.07l2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm17.92.11h.07l2.89,1.67L206.09,356l-3-1.68,2.44-1.42Zm-9.38.19h.06l2.9,1.67-2.45,1.41-3-1.68,2.44-1.41Zm17.92.11.07,0,2.89,1.67-2.45,1.41-3-1.68,2.44-1.41Zm9.51.86.06,0,2.9,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-48.52.74h.07l7.42,4.29-2.45,1.41-7.52-4.29,2.45-1.42Zm8.54.3h.07l2.89,1.67-2.45,1.42-3-1.68,2.45-1.42Zm8.54.3h.07l2.89,1.67-2.45,1.42-3-1.68,2.44-1.42Zm17.92.12h.07l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm-9.38.18h.06l2.9,1.68-2.45,1.41-3-1.68,2.44-1.41Zm18.89.68h.06l2.9,1.67-2.45,1.41-3-1.68,2.44-1.41Zm-31.44,1.34h.07l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm8.54.3s.06,0,.06,0l2.9,1.67-2.45,1.41-3-1.68,2.44-1.41Zm8.54.3h.06l2.9,1.67-2.45,1.42-3-1.69,2.44-1.41Zm10.35.37h.07l2.89,1.67-2.45,1.42-3-1.68,2.44-1.42ZM184.17,360h.07l7.42,4.29-2.45,1.41-7.52-4.29,2.45-1.42Zm8.54.3h.07l2.89,1.67-2.45,1.42-3-1.68,2.45-1.41Zm8.54.3h.06l2.9,1.67-2.45,1.42-3-1.68,2.45-1.41Zm10.67,1.54H212l1.25.71-2.45,1.41-1.34-.73,2.43-1.4Zm-14.68.78h.07l2.89,1.67-2.45,1.41-3-1.68,2.45-1.41Zm10.67,1.53H208l1.25.71-2.44,1.42-1.35-.73,2.44-1.41Zm-14.67.78h.06l2.89,1.67-2.45,1.42-3-1.68,2.45-1.42Zm10.66,1.53a.1.1,0,0,1,.07,0l1.26.7-2.45,1.42-1.35-.73,2.44-1.4Zm-4,2.32H200l1.26.71-2.45,1.41-1.35-.72,2.44-1.41Z",
    style: {
      fill: "#8E4DFE"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "freepik--Hand--inject-431",
    d: "M236,300.32a51.15,51.15,0,0,0-8.7-9.81c-3.93-3.22-5.54-4.2-12.62-7.59l-10.52,14.16,3.16.95c1.33.47,2,.6,2.55,1.83a32.19,32.19,0,0,1,.59,4.22A33.31,33.31,0,0,0,212,311c1.11,3.34,1.83,3.11,3.83,5.76,1.86,2.46,2.61,4.09,3.64,4s2.32-2.15,1.79-4.42-2.42-5.53-2.69-6.47-.63-2.33,1.81-1.56,7,6.36,9.21,8.65,3.58,5.79,5.65,7.33,5.18,1.47,4.31-1.88c.33-1.94,1.52-5.28,1.81-8.38S238.26,303.64,236,300.32Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.62,354l-5.18-2.9a6.34,6.34,0,0,0-5.87-.07l-25.8,14.89-3.39-2a5.74,5.74,0,0,0-5.23,0l-31.32,18.2c-1.45.84-1.45,2.19,0,3l3.3,1.91-37.28,21.51c-1.64.95-1.63,2.49,0,3.43l5.19,3a6.57,6.57,0,0,0,5.92,0l37.28-21.53a5.82,5.82,0,0,0,5.24,0l31.2-18.14c1.41-.81,1.44-2.11.11-3l25.78-14.89C371.21,356.51,371.23,354.94,369.62,354Z",
    style: {
      fill: "#8E4DFE",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,327.32l6.6-78.44a6.7,6.7,0,0,0-2.93-5.88,7.47,7.47,0,0,0-6.73.13L256.05,300a8.62,8.62,0,0,0-3.81,6l-6.6,78.44a6.7,6.7,0,0,0,2.93,5.88,7.46,7.46,0,0,0,6.73-.12l98.58-56.92A8.59,8.59,0,0,0,357.68,327.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,327.32l6.6-78.44a6.7,6.7,0,0,0-2.93-5.88,7.47,7.47,0,0,0-6.73.13L256.05,300a7.8,7.8,0,0,0-2.53,2.55l12.08,7-.74,75.15,89-51.4A8.59,8.59,0,0,0,357.68,327.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.16,388.24l6.6-78.44a8.57,8.57,0,0,1,3.8-6l97.37-56.27c1.92-1.1,2.72-.26,2.54,1.95l-4.79,77.84a8.59,8.59,0,0,1-3.8,6L255.3,390.24C253.38,391.34,252,390.45,252.16,388.24Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.76,319.18c.3-3.63,2.85-7.92,5.69-9.56s4.91,0,4.61,3.6-2.85,7.91-5.69,9.56S305.46,322.81,305.76,319.18Z",
    style: {
      fill: "#8E4DFE"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.1 349.45 326.17 337.21 322.58 335.13 301.52 347.38 305.1 349.45",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.94,373.13l-25.65,14.81a3.12,3.12,0,0,1-1.65.37,3.18,3.18,0,0,1-1.39-.35l0,0-11.29-6.52-.06,0a3.29,3.29,0,0,1-1.46-2.61v-.6c0-1,.67-1.38,1.52-.89l6.82,3.93,1.52.88-.34-1.73-2.4-33,3.58,2.07,21.07-12.23,11,33.29A2.65,2.65,0,0,1,335.94,373.13Z",
    style: {
      fill: "#37474f"
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "294.87 377.16 303.62 372.11 305.39 383.88 294.87 377.16"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M305.1,349.45l-3.58-2.07,2.4,33c.2.95-.35,1.34-1.18.85l-6.82-3.93c-.85-.49-1.52-.09-1.52.89v.6a3.29,3.29,0,0,0,1.46,2.61l.06,0,11.29,6.52,0,0a3.18,3.18,0,0,0,1.39.35Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Body--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.5,208.05c5.53,1.31,11.21,5.91,14.77,17.09,4.25,13.35,8.31,42.94,8.31,42.94l34.07,14.84-10.52,14.16s-22.48-5.58-33.32-8.74c-11.7-3.41-11.31-6.92-15.05-26.23-2.42-12.5-5-27.86-5-27.86C152,223.74,157.5,208.05,157.5,208.05Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.25,221.49c-1.32-5-3.76-12.77-17.33-14.42l-5.69,25.57s2.55,14.71,5,27.68c9.35-.54,17.6-1.3,24.3-7.82C176.28,241.15,174.41,229.67,172.25,221.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Chest--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M168,239.76c1.06-22-5.08-30.52-13-32.69-.21,0-15.6-1.43-24.57-1-10.92.53-23.31,3.21-27.28,5-6,2.67-9.53,11.41-11.78,26.81-1.59,10.93-3.44,24.05-5.79,44.83-1.44,12.7-2.61,17.66-1.6,31.55,14.61,7.25,68.06,6,80-13.69-1-4.67-.83-9.95-.83-19.15C163.67,265.36,167.61,246.68,168,239.76Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Head--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.48,196.58c-.14-6.51-5.47-14.06-7.5-20-2-5.74-3-10.12-1.93-15.09.63-2.94,3.09-6.69,5.42-7.21-.92-11.41,8.12-15.31,12.67-15.71a46.56,46.56,0,0,0,6.34-.8c2.54-.65,3.36-2.49,5.53-3.84,3.74-2.33,9.34-1.57,10.84,3,2.63-2.53,5.62-2,9-.62a6,6,0,0,1,3.54,7.35c5-1.91,8.78,2,8.8,4.77,0,2.06-.66,3.69.39,5.68,1.18,2.24,4,2.62,5.08,1.11,0,2.92-1.38,4.93-4.45,4.32a6.52,6.52,0,0,1,0,5.56,6,6,0,0,1-5.94,3.29c-.56,1.52-.84,2.94-2,4.15a10.44,10.44,0,0,1-4.13,2.74c-5,1.54-10.3,1.5-15.5,1.8l-6.17.36c-.36,0-2.18-.14-2.44.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,187.24c4.06,3.32,7.51.88,7.51.88L122.11,209c2.16,9.46,17.24,13.23,23.17,11.52s5.73-5.12,2.85-10.67l.89-3.36a63.29,63.29,0,0,0,7.6.78c5.07,0,9.41-3.43,11.63-8.61A56.62,56.62,0,0,0,172,177.4a19,19,0,0,1,.5-5.26c1.17-4.56.73-7.37.11-11.44-4.82-5.21-17.26-8.58-30.13-3.15.33,7.22-3.22,12.39-8.73,14.31,0,1.93-.51,6.76-3.61,6.21-2.24-.39-2-3.23-3.91-6.06s-7.23-4.28-9.85-.93C112.72,175.77,113.55,183.6,118,187.24Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.41 186.31 157.35 189.11 157.01 171.46 165.41 186.31",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149,206.49c-7.75-2.1-13.62-3.84-16.88-10.17a49.86,49.86,0,0,1-3.38-10s-.22,7.11,1.66,12.22c1.44,3.94,5.66,7.86,17.88,10.75Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.85,176a2.24,2.24,0,1,1-2-2.55A2.28,2.28,0,0,1,150.85,176Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.89,166.63l-5,2.17a2.88,2.88,0,0,1,1.49-3.7A2.69,2.69,0,0,1,150.89,166.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.76,189.58l7.07,3.27a4.1,4.1,0,0,1-5.32,1.93A3.81,3.81,0,0,1,147.76,189.58Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,195.1a4.6,4.6,0,0,0-4.22-4.46,3.76,3.76,0,0,0,2.09,4.14A4,4,0,0,0,151.64,195.1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.77,170.89,165,168.18a2.64,2.64,0,0,1,3.68-1.12A2.89,2.89,0,0,1,169.77,170.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.08,177.07a2.24,2.24,0,1,1-1.77-2.71A2.28,2.28,0,0,1,168.08,177.07Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arm--inject-431"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.75,279.08C76.08,259.32,80.61,244.63,85,231c2.61-8,8.86-12.56,18.42-16.67,10.28,7.33,6,30.22,4.5,35.58l-7.58,33.06s8.28,6.58,17.65,13.45c7.92,5.81,13.25,9.3,22.6,10.4s13.14.79,18,2.91c2.6,1.12,8.52,3.74,10.54,4.76s5.64,4.67,9,7.13c3.16,2.51-.78,3.9-3.23,3.19a31.47,31.47,0,0,1-7.35-3.56,41.89,41.89,0,0,0-6.3-2.41,37.81,37.81,0,0,1,1.34,7.36c0,1.34.3,3-.87,4a10.49,10.49,0,0,1-2.81,1.16,2.05,2.05,0,0,1-.56,1.3,3.35,3.35,0,0,1-2.39.62,9.67,9.67,0,0,1-1.36-.21,2.49,2.49,0,0,1-1.51,1.94,10.79,10.79,0,0,1-5.74.21c-.28-.12-2.41-1.27-3-1.59-.9-.48-1.71-.74-2.11-1.33s.84-2.31,1.94-2.49a11.23,11.23,0,0,1,3.65.23,12.92,12.92,0,0,1-1.07-3.14c-1-1.59-8.17,0-14.54-1.07-4.82-.83-8.3-5.4-10.46-6.37-13.87-6.24-24.21-11-38.44-19C71.64,293.77,72.59,288.93,73.75,279.08Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.51,319.22c-.74-1.81-1.88-4-3.26-4.48a16.73,16.73,0,0,1,2,4.05C161.68,319,162.1,319.09,162.51,319.22Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.93,331.27a15,15,0,0,0,.12-4,37,37,0,0,0-.51-3.93,17.14,17.14,0,0,0-1.08-3.85,7.16,7.16,0,0,0-2.38-3.17,5.52,5.52,0,0,1,1.09,1.61,11.46,11.46,0,0,1,.75,1.77,27.68,27.68,0,0,1,.87,3.78c.25,1.28.46,2.57.68,3.86A33.57,33.57,0,0,1,158.93,331.27Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.62,333a18.73,18.73,0,0,0,0-3.89,33.12,33.12,0,0,0-.59-3.85,27.67,27.67,0,0,0-1.06-3.76,7.57,7.57,0,0,0-2-3.33,5.12,5.12,0,0,1,.87,1.69c.21.59.4,1.2.56,1.82.32,1.24.62,2.48.88,3.74C153.82,327.9,154.31,330.41,154.62,333Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16,329.72a6.65,6.65,0,0,1,1.61.23c.52.12.89.38,1.54.59l-.26-.42a1.57,1.57,0,0,0,.1.77,2,2,0,0,0,.37.6,2.28,2.28,0,0,0,1.09.71,6.38,6.38,0,0,1-.66-1,3.6,3.6,0,0,1-.16-.5,1.82,1.82,0,0,1,0-.45l0-.3-.3-.12a4.78,4.78,0,0,0-1.52-.32A3.28,3.28,0,0,0,144.16,329.72Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.07,211.07c-14.32,3.21-17,11.6-19.27,18.67-2.4,7.56-4,14.46-7.72,29.58,6.32,5.54,16.36,7.66,29.24,7.15,2-8.28,4.16-17.47,5-21C112.08,238.53,113.77,217,103.07,211.07Z",
    style: {
      fill: "#263238"
    }
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditingbodytextAmico);
export default __webpack_public_path__ + "static/media/Editing body text-amico.eed6351aa985bbfcd65ba40d59962420.svg";
export { ForwardRef as ReactComponent };